const coordinates_1346 = [
  [
    [47.25211, 39.192151],
    [47.404391, 39.357795],
    [47.881355, 41.613548],
    [49.02076, 42.576846],
    [50.241935, 44.714153],
    [50.270032, 45.439724],
    [50.192726, 45.945425],
    [49.853923, 46.209269],
    [49.075665, 46.539074],
    [48.786962, 47.275638],
    [48.5257, 48.25363],
    [48.474742, 49.192471],
    [48.452887, 50.193074],
    [48.868328, 51.453874],
    [48.140432, 54.114301],
    [46.646608, 53.244022],
    [46.812279, 52.507594],
    [46.714444, 52.194846],
    [46.893422, 51.312396],
    [46.490262, 49.95486],
    [46.177548, 49.92164],
    [45.765224, 48.932343],
    [45.550217, 48.910359],
    [44.509826, 46.997717],
    [44.338387, 46.899778],
    [44.148316, 45.480067],
    [44.195596, 44.29291],
    [44.164081, 42.468206],
    [43.863842, 41.566846],
    [43.003442, 40.536583],
    [43.142782, 40.242118],
    [43.354842, 39.989297],
    [44.3541, 38.183955],
    [44.628987, 37.766251],
    [44.644622, 37.48595],
    [44.841946, 37.265923],
    [44.900487, 37.304225],
    [45.022922, 37.111862],
    [45.102462, 36.771104],
    [45.097615, 36.729883],
    [45.142191, 36.599351],
    [45.204151, 36.597016],
    [45.231237, 36.683564],
    [45.221565, 36.726159],
    [45.238974, 36.756388],
    [45.287303, 36.977606],
    [45.318213, 36.959743],
    [45.299862, 36.79486],
    [45.373783, 36.758308],
    [45.415768, 36.759611],
    [45.443976, 36.782776],
    [45.45517, 36.852413],
    [45.433009, 36.927985],
    [45.345245, 37.168439],
    [45.352966, 37.381413],
    [45.376122, 37.515771],
    [45.417588, 37.559739],
    [45.679176, 37.605082],
    [45.718501, 37.745233],
    [45.747258, 37.779583],
    [45.753008, 37.822178],
    [46.036873, 37.9374],
    [46.062607, 38.106405],
    [46.051243, 38.122726],
    [46.027339, 38.128371],
    [46.005476, 38.082882],
    [45.953942, 38.097997],
    [45.988303, 38.124103],
    [45.995936, 38.146774],
    [46.037695, 38.144618],
    [46.118799, 38.174931],
    [46.15496, 38.231266],
    [46.279438, 38.255998],
    [46.387533, 38.055391],
    [46.386586, 38.012796],
    [46.365742, 38.026536],
    [46.351525, 37.993559],
    [46.414997, 37.883637],
    [46.679453, 37.725625],
    [46.684759, 37.73462],
    [46.652194, 37.803327],
    [46.635223, 37.925615],
    [46.639466, 38.010804],
    [46.646101, 38.050897],
    [46.692984, 38.127155],
    [46.700048, 38.212001],
    [46.743084, 38.288829],
    [46.74149, 38.294752],
    [46.716998, 38.288765],
    [46.685212, 38.305253],
    [46.664953, 38.334451],
    [46.656907, 38.395204],
    [46.654079, 38.430241],
    [46.643709, 38.502378],
    [46.663304, 38.545598],
    [46.661419, 38.573079],
    [46.667781, 38.591933],
    [46.693455, 38.596742],
    [46.724765, 38.574429],
    [46.735825, 38.525652],
    [46.747119, 38.505427],
    [46.745472, 38.473824],
    [46.75394, 38.449779],
    [46.749942, 38.428481],
    [46.751118, 38.41268],
    [46.736296, 38.402033],
    [46.721235, 38.406161],
    [46.71229, 38.424367],
    [46.711584, 38.414405],
    [46.721941, 38.390395],
    [46.733708, 38.389708],
    [46.78404, 38.39967],
    [46.82728, 38.416151],
    [46.882183, 38.494775],
    [46.857773, 38.546301],
    [46.870449, 38.618438],
    [46.870918, 38.697444],
    [46.907521, 38.80874],
    [46.917371, 38.847213],
    [46.953473, 38.869197],
    [46.973155, 38.904235],
    [46.958628, 38.915914],
    [47.044259, 39.105929],
    [47.04075, 39.108849],
    [47.0349, 39.106616],
    [47.026827, 39.120356],
    [47.035432, 39.186358],
    [47.034432, 39.193771],
    [47.019051, 39.245294],
    [47.0242, 39.294072],
    [47.054417, 39.301926],
    [47.056522, 39.273081],
    [47.080375, 39.250066],
    [47.08318, 39.228082],
    [47.090094, 39.23099],
    [47.092782, 39.25057],
    [47.11358, 39.255036],
    [47.115216, 39.250055],
    [47.12386, 39.235972],
    [47.138324, 39.22502],
    [47.162857, 39.236841],
    [47.187776, 39.206183],
    [47.250199, 39.202165],
  ],
];

const coordinates_1347 = [
  [
    [46.54055, 31.578866],
    [46.58422, 31.513623],
    [46.581861, 31.501944],
    [46.549629, 31.522585],
    [46.498605, 31.602965],
    [46.421979, 31.703269],
    [46.437727, 31.712114],
    [46.447426, 31.698717],
    [46.472023, 31.705931],
    [46.484317, 31.747115],
    [46.449898, 31.913497],
    [46.43678, 31.953222],
    [46.439146, 31.972644],
    [46.44619, 31.988779],
    [46.452577, 32.00063],
    [46.450567, 32.014027],
    [46.439685, 32.028282],
    [46.416902, 32.035198],
    [46.394649, 32.058213],
    [46.379019, 32.038977],
    [46.38465, 32.023642],
    [46.360541, 32.005972],
    [46.338609, 31.921567],
    [46.33766, 31.838439],
    [46.313478, 31.757372],
    [46.281692, 31.737534],
    [46.290233, 31.767762],
    [46.2722, 31.77738],
    [46.264131, 31.773258],
    [46.258434, 31.791121],
    [46.27204, 31.79342],
    [46.269548, 31.811969],
    [46.263113, 31.813759],
    [46.264241, 31.823635],
    [46.259384, 31.873498],
    [46.293922, 31.900581],
    [46.288466, 31.940428],
    [46.261888, 31.955886],
    [46.254055, 31.973748],
    [46.245033, 32.027335],
    [46.251681, 32.055503],
    [46.226985, 32.082296],
    [46.200009, 32.116795],
    [46.195256, 32.158703],
    [46.170059, 32.185497],
    [46.169715, 32.203011],
    [46.184929, 32.20782],
    [46.178273, 32.239423],
    [46.167337, 32.227743],
    [46.144982, 32.234623],
    [46.114087, 32.220431],
    [46.049313, 32.53096],
    [46.096948, 32.770041],
    [46.098852, 33.031105],
    [46.087424, 33.228965],
    [46.003544, 33.393848],
    [45.988279, 33.605447],
    [45.839229, 33.536746],
    [45.848795, 33.457053],
    [45.762637, 33.245453],
    [45.791371, 33.137852],
    [45.730054, 33.135104],
    [45.59953, 32.808087],
    [45.395461, 32.439848],
    [45.370382, 32.478321],
    [45.329848, 32.475573],
    [45.293148, 32.659692],
    [45.35644, 32.761285],
    [45.332309, 32.952274],
    [45.133085, 33.247689],
    [45.137929, 33.291514],
    [45.165797, 33.306524],
    [45.168108, 33.353177],
    [45.093786, 33.525205],
    [44.864532, 33.585663],
    [44.792459, 33.503221],
    [44.65195, 33.514213],
    [44.575698, 33.338338],
    [44.490089, 33.471375],
    [44.478332, 33.546946],
    [44.477352, 33.6129],
    [44.412644, 33.64038],
    [44.406758, 33.700837],
    [44.371429, 33.72557],
    [44.394984, 33.882208],
    [44.375355, 33.95778],
    [44.411123, 34.138107],
    [44.482251, 34.18713],
    [44.48715, 34.253083],
    [44.536115, 34.302548],
    [44.537094, 34.357509],
    [44.581885, 34.363261],
    [44.594599, 34.379062],
    [44.685962, 34.436027],
    [44.730369, 34.52053],
    [44.808586, 34.82418],
    [44.815844, 35.016724],
    [44.772964, 35.044205],
    [44.782712, 35.13489],
    [44.894261, 35.18947],
    [44.908633, 35.248418],
    [44.956757, 35.260097],
    [44.946066, 35.369262],
    [44.942664, 35.391934],
    [44.954042, 35.394039],
    [44.975594, 35.357822],
    [44.99235, 35.371563],
    [45.008858, 35.42515],
    [45.105952, 35.518889],
    [45.075897, 35.720843],
    [44.98855, 35.840383],
    [44.990493, 35.8871],
    [45.025446, 36.050608],
    [45.014768, 36.249842],
    [45.086563, 36.465564],
    [45.318261, 36.526976],
    [45.356874, 36.664379],
    [45.443007, 36.618841],
    [45.484977, 36.111638],
    [45.392471, 35.979732],
    [45.481125, 35.84233],
    [45.404043, 35.715919],
    [45.334578, 35.682943],
    [45.29508, 35.523956],
    [45.704069, 35.045287],
    [46.016897, 34.878213],
    [46.081709, 35.175002],
    [46.404628, 35.463548],
    [46.599355, 35.851022],
    [46.638971, 36.211017],
    [46.497872, 36.136761],
    [46.484636, 36.169738],
    [46.617799, 36.296148],
    [46.700742, 36.381338],
    [46.770392, 36.697363],
    [46.620629, 36.743837],
    [46.627231, 36.785057],
    [46.715809, 36.863377],
    [46.812702, 36.92246],
    [46.922975, 37.246789],
    [46.849767, 37.282514],
    [46.88169, 37.384191],
    [47.065351, 37.562815],
    [47.057867, 38.09044],
    [47.017301, 38.08414],
    [47.087166, 38.204405],
    [47.119579, 38.455674],
    [47.085927, 38.584832],
    [47.25211, 39.192151],
    [47.404391, 39.357795],
    [47.881355, 41.613548],
    [49.02076, 42.576846],
    [50.241935, 44.714153],
    [50.270032, 45.439724],
    [50.192726, 45.945425],
    [49.853923, 46.209269],
    [49.075665, 46.539074],
    [48.786962, 47.275638],
    [48.5257, 48.25363],
    [48.474742, 49.192471],
    [48.452887, 50.193074],
    [48.868328, 51.453874],
    [48.140432, 54.114301],
    [48.140432, 54.114301],
    [49.25705, 55.653391],
    [52.059246, 53.911249],
    [52.684708, 52.953461],
    [53.795784, 51.502319],
    [55.362566, 49.328613],
    [49.687, 33.4389],
    [49.079488, 33.435967],
    [48.84348, 34.202314],
    [48.495223, 34.990995],
    [48.300096, 35.183382],
    [47.780405, 35.216362],
    [47.410432, 34.759238],
    [47.070589, 33.94674],
    [46.855143, 33.584874],
    [46.464775, 32.361756],
    [46.549523, 31.74667],
  ],
  [
    [41.37, 28.955],
    [41.480805, 28.359943],
    [41.985015, 28.090602],
    [42.469058, 27.716823],
    [42.466019, 27.49514],
    [40.957086, 24.527203],
    [40.616037, 24.494223],
    [40.524761, 24.599806],
    [40.560243, 24.819676],
    [40.803935, 24.827921],
    [40.953456, 25.108255],
    [39.852829, 25.044687],
    [39.166271, 25.825197],
    [38.345964, 25.810306],
    [36.813683, 26.997604],
    [35.982451, 27.679202],
    [35.8501, 27.766394],
    [36.142311, 29.990347],
    [36.129556, 30.534559],
    [36.480104, 30.591834],
  ],
  [
    [35.399125, 32.994959],
    [35.363296, 33.429202],
    [35.44389, 33.890929],
    [35.743168, 34.528552],
    [35.715856, 34.626078],
    [35.618233, 34.633423],
    [35.618233, 34.633423],
    [35.246741, 33.940764],
    [34.991894, 34.115282],
    [34.954619, 34.105667],
    [34.932104, 34.078183],
    [34.945614, 33.951758],
    [34.932104, 33.869306],
    [34.918593, 33.720894],
    [34.810421, 33.66043],
    [34.688557, 33.330625],
    [34.638857, 33.116251],
    [34.615409, 33.031248],
    [34.55888, 33.049112],
    [34.552094, 32.937803],
    [34.567998, 32.929369],
    [34.652697, 32.873447],
    [34.611171, 32.718892],
    [34.712831, 32.383591],
    [35.086765, 32.235742],
    [35.115977, 32.293457],
    [35.064287, 32.417134],
    [35.187839, 32.56005],
    [35.214771, 32.683727],
    [35.167634, 32.837636],
    [35.27085, 32.914567],
    [35.423189, 32.908344],
  ],
  [
    [39.68394, 22.902934],
    [38.747657, 20.88013],
    [38.718198, 20.556902],
    [38.223078, 20.330649],
    [38.167495, 20.317911],
    [37.668603, 20.682785],
    [36.741085, 21.617232],
    [36.633713, 21.806918],
    [36.415204, 22.455534],
    [36.113471, 22.970796],
    [35.265804, 23.509478],
    [35.1884, 23.586889],
    [34.915215, 24.773644],
    [34.972626, 26.153441],
    [35.012564, 26.257365],
    [35.187839, 26.338625],
    [35.412557, 27.260714],
    [35.913801, 27.322559],
    [37.581589, 25.385966],
    [38.904393, 24.655263],
    [39.446799, 24.298004],
    [39.68394, 22.902934],
  ],
  [
    [38.268915, 15.657571],
    [38.301927, 15.54211],
    [38.272756, 15.218741],
    [38.217818, 15.228972],
    [38.135907, 15.11955],
    [38.151972, 15.044872],
    [38.191042, 14.918257],
    [38.169654, 14.747796],
    [38.03349, 13.994742],
    [38.126455, 13.506151],
    [38.223752, 13.315699],
    [38.19772, 13.102183],
    [38.182609, 12.727112],
    [37.897614, 12.424112],
    [37.684907, 12.429609],
    [37.541311, 12.660472],
    [37.082571, 13.885437],
    [36.779592, 14.47359],
    [36.685215, 14.741798],
    [36.636744, 15.09359],
    [36.994327, 15.349802],
    [37.272414, 15.248245],
    [37.58295, 15.174474],
    [38.262446, 15.64692],
    [38.268915, 15.657571],
  ],
  [
    [38.858157, 8.635694],
    [38.954336, 8.406224],
    [39.107952, 8.237199],
    [39.145838, 8.215875],
    [39.166304, 8.230913],
    [39.231455, 8.372477],
    [39.98396, 8.387154],
    [40.56233, 8.139803],
    [40.934784, 8.178281],
    [41.105484, 8.274947],
    [41.126177, 8.321699],
    [41.083751, 8.365579],
    [40.899241, 8.255644],
    [40.82654, 8.476889],
    [40.918961, 8.711875],
    [41.135745, 9.024389],
    [41.250193, 9.131982],
    [41.313145, 9.344981],
    [41.314176, 9.388644],
    [41.231606, 9.483463],
    [41.130314, 9.576908],
    [41.002962, 9.659359],
    [40.926484, 9.757813],
    [40.516409, 9.840144],
    [40.07019, 9.746807],
    [39.114079, 9.611218],
    [39.066647, 9.526903],
    [39.192352, 9.175111],
    [39.047452, 9.043189],
    [38.940719, 8.999293],
    [38.858157, 8.635694],
  ],
  [
    [41.360576, 9.233209],
    [41.562289, 9.384369],
    [41.692527, 9.411435],
    [41.931401, 9.428157],
    [42.101534, 9.556338],
    [42.557632, 9.54643],
    [43.001132, 9.477636],
    [43.007158, 9.323727],
    [42.836199, 9.296244],
    [42.686978, 9.298992],
    [42.736044, 9.224825],
    [42.745121, 9.133441],
    [42.698207, 9.053051],
    [42.654793, 9.03931],
    [42.641283, 8.885641],
    [42.583675, 8.712494],
    [42.375032, 8.532475],
    [42.375032, 8.532475],
    [42.303849, 8.569453],
    [42.275404, 8.682823],
    [42.237796, 8.538533],
    [42.132094, 8.551706],
    [42.050567, 8.709737],
    [41.962809, 8.587435],
    [41.872117, 8.580769],
    [41.8987, 8.781401],
    [41.747238, 8.657724],
    [41.714186, 8.695811],
    [41.695731, 8.782385],
    [41.678297, 8.900565],
    [41.641361, 8.811243],
    [41.593108, 8.765894],
    [41.559206, 8.766087],
    [41.504721, 8.837545],
    [41.422392, 9.097266],
    [41.381188, 9.080776],
    [41.383249, 9.137118],
    [41.362638, 9.176969],
    [41.360576, 9.233209],
  ],
  [
    [44.009608, 4.805361],
    [43.469864, 4.29966],
    [43.362131, 4.547014],
    [43.182148, 5.349539],
    [43.165623, 5.599867],
    [43.425497, 5.610861],
    [43.509219, 5.514667],
    [43.837003, 5.410229],
    [43.959708, 5.096703],
    [44.009608, 4.805361],
  ],
  [
    [39.969753, 3.184574],
    [39.915003, 2.87126],
    [39.610978, 2.321585],
    [39.517284, 2.355561],
    [39.511722, 2.390407],
    [39.525494, 2.456368],
    [39.46721, 2.463239],
    [39.449185, 2.533323],
    [39.558324, 2.655625],
    [39.496888, 2.746322],
    [39.47145, 2.718838],
    [39.398265, 2.736702],
    [39.354742, 2.790296],
    [39.352091, 2.913536],
    [39.345051, 2.97157],
    [39.304816, 2.987827],
    [39.256981, 3.059285],
    [39.35368, 3.235181],
    [39.381283, 3.272284],
    [39.505365, 3.305265],
    [39.574204, 3.40558],
    [39.629226, 3.408065],
    [39.631341, 3.446542],
    [39.713789, 3.48502],
    [39.751809, 3.464407],
    [39.787698, 3.339356],
    [39.733858, 3.250034],
    [39.7782, 3.135976],
    [39.834707, 3.129573],
    [39.831016, 3.144006],
    [39.834707, 3.172864],
    [39.859748, 3.199317],
    [39.864228, 3.189698],
    [39.879247, 3.191759],
    [39.889258, 3.206875],
    [39.893209, 3.189698],
    [39.878457, 3.167367],
    [39.872133, 3.15122],
    [39.865545, 3.136104],
    [39.870552, 3.131638],
    [39.85843, 3.104841],
    [39.870025, 3.086977],
    [39.888994, 3.078732],
    [39.909539, 3.089038],
    [39.904272, 3.103811],
    [39.89795, 3.111712],
    [39.910855, 3.116179],
    [39.914279, 3.127172],
    [39.926391, 3.133356],
    [39.917702, 3.148534],
    [39.944555, 3.202052],
    [39.960609, 3.217855],
    [39.969753, 3.184574],
  ],
  [
    [44.432309, 8.736176],
    [44.563567, 8.793892],
    [44.635925, 9.022007],
    [44.587044, 9.153696],
    [44.489158, 9.186676],
    [44.347913, 9.249889],
    [44.332321, 9.211191],
    [44.296947, 9.223558],
    [44.320041, 9.141107],
    [44.359819, 9.14042],
    [44.399694, 8.912008],
    [44.432309, 8.736176],
  ],
  [
    [45.302422, 12.136618],
    [45.404717, 11.688633],
    [45.6798, 11.614427],
    [45.835019, 12.004442],
    [45.844586, 12.490904],
    [45.804393, 12.710774],
    [45.637567, 12.999353],
    [45.429781, 12.430137],
    [45.302422, 12.136618],
  ],
  [
    [42.643367, 18.089614],
    [42.648165, 18.061787],
    [42.659022, 18.05629],
    [42.663835, 18.060129],
    [42.691836, 18.084137],
    [42.691836, 18.133608],
    [42.677703, 18.151129],
    [42.660032, 18.152847],
    [42.640084, 18.127424],
    [42.638316, 18.111277],
    [42.643367, 18.089614],
  ],
  [
    [43.506791, 16.435852],
    [43.49932, 16.42692],
    [43.506791, 16.387068],
    [43.515724, 16.403073],
    [43.516253, 16.426244],
    [43.522197, 16.421967],
    [43.530411, 16.438458],
    [43.538158, 16.446527],
    [43.53318, 16.478133],
    [43.530691, 16.521077],
    [43.503305, 16.529665],
    [43.49932, 16.525199],
    [43.498822, 16.459925],
    [43.500317, 16.44],
    [43.507857, 16.436789],
    [43.506791, 16.435852],
  ],
];

const coordinates_1348 = [
  [
    [50.707466, -1.516365],
    [50.708689, -1.491177],
    [50.729121, -1.430713],
    [50.728035, -1.412161],
    [50.741941, -1.354102],
    [50.753889, -1.346887],
    [50.759536, -1.331084],
    [50.767137, -1.31906],
    [50.768657, -1.307723],
    [50.766349, -1.296215],
    [50.763201, -1.290203],
    [50.766784, -1.274916],
    [50.761491, -1.260631],
    [50.74482, -1.232371],
    [50.736998, -1.203513],
    [50.734825, -1.180839],
    [50.734391, -1.156103],
    [50.720917, -1.101823],
    [50.699176, -1.082584],
    [50.684386, -1.057849],
    [50.680036, -1.06472],
    [50.669592, -1.091516],
    [50.665267, -1.094436],
    [50.663309, -1.102275],
    [50.662792, -1.110748],
    [50.65863, -1.135768],
    [50.643474, -1.157295],
    [50.598167, -1.168975],
    [50.590757, -1.182717],
    [50.568084, -1.309829],
    [50.602089, -1.356552],
    [50.630844, -1.422282],
    [50.650168, -1.47162],
    [50.665621, -1.489141],
    [50.656698, -1.584647],
    [50.662003, -1.593299],
    [50.66592, -1.57114],
    [50.673645, -1.572171],
    [50.678975, -1.549325],
    [50.688655, -1.543616],
    [50.690273, -1.545049],
    [50.689838, -1.539209],
    [50.692611, -1.53543],
    [50.700875, -1.535773],
    [50.703919, -1.529847],
    [50.707887, -1.522289],
  ],
  [
    [39.920533, 3.965892],
    [39.785587, 4.275084],
    [39.798052, 4.29943],
    [39.866599, 4.310767],
    [39.876695, 4.329735],
    [39.882688, 4.312729],
    [39.886006, 4.314093],
    [39.899761, 4.308649],
    [39.898971, 4.300748],
    [39.935605, 4.280777],
    [39.942153, 4.285642],
    [39.956892, 4.283409],
    [39.960757, 4.285241],
    [39.962862, 4.280947],
    [39.96773, 4.277941],
    [39.962928, 4.266947],
    [39.965691, 4.263254],
    [39.966612, 4.256985],
    [39.976018, 4.262739],
    [39.978847, 4.263528],
    [39.981675, 4.266963],
    [39.982727, 4.265417],
    [39.982727, 4.26035],
    [39.985752, 4.261896],
    [39.987725, 4.259577],
    [39.987988, 4.257344],
    [39.994169, 4.258632],
    [39.996076, 4.271258],
    [39.998706, 4.267049],
    [40.000153, 4.253565],
    [40.001468, 4.251676],
    [39.999873, 4.225424],
    [40.005068, 4.215915],
    [40.01953, 4.214884],
    [40.025281, 4.196383],
    [40.034614, 4.196727],
    [40.035402, 4.184531],
    [40.026464, 4.180752],
    [40.028567, 4.171476],
    [40.034877, 4.176285],
    [40.038557, 4.163918],
    [40.061027, 4.174911],
    [40.070781, 4.139672],
    [40.053702, 4.104287],
    [40.074196, 4.098103],
    [40.085591, 4.100419],
    [40.09045, 4.094064],
    [40.088349, 4.085819],
    [40.095572, 4.074997],
    [40.090713, 4.071046],
    [40.081651, 4.085819],
    [40.068909, 4.079647],
    [40.071011, 4.077242],
    [40.066545, 4.073463],
    [40.060895, 4.074322],
    [40.05853, 4.054239],
    [40.054063, 4.050804],
    [40.057085, 4.045307],
    [40.070617, 4.031565],
    [40.067333, 4.025725],
    [40.063523, 4.02521],
    [40.056165, 3.970807],
    [40.062636, 3.959783],
    [40.057118, 3.944323],
    [40.062472, 3.938029],
    [40.062603, 3.932017],
    [40.057873, 3.917931],
    [40.048281, 3.919821],
    [40.057348, 3.905907],
    [40.060238, 3.899895],
    [40.053964, 3.819702],
    [40.017164, 3.787752],
    [39.996915, 3.791187],
    [39.991391, 3.819358],
    [39.962188, 3.826229],
    [39.922178, 3.815235],
    [39.919809, 3.821763],
    [39.917768, 3.838182],
    [39.914081, 3.90483],
    [39.929879, 3.950865],
  ],
  [
    [38.916281, 1.489088],
    [38.942655, 1.531109],
    [38.975759, 1.537297],
    [38.988035, 1.559627],
    [38.977894, 1.58608],
    [39.008313, 1.590148],
    [39.010714, 1.59908],
    [39.021068, 1.598311],
    [39.026935, 1.608703],
    [39.023068, 1.616089],
    [39.027135, 1.622788],
    [39.028136, 1.621586],
    [39.029136, 1.617377],
    [39.03467, 1.623046],
    [39.03747, 1.619954],
    [39.036403, 1.610249],
    [39.044736, 1.611279],
    [39.046819, 1.607733],
    [39.062016, 1.590384],
    [39.074461, 1.593589],
    [39.072262, 1.599345],
    [39.080924, 1.613946],
    [39.08199, 1.610854],
    [39.079858, 1.603039],
    [39.084055, 1.601493],
    [39.090251, 1.605959],
    [39.096129, 1.595888],
    [39.100393, 1.592968],
    [39.097195, 1.58644],
    [39.099327, 1.565999],
    [39.093332, 1.561018],
    [39.101442, 1.555644],
    [39.110167, 1.540458],
    [39.114162, 1.545182],
    [39.119889, 1.534618],
    [39.115161, 1.52295],
    [39.117492, 1.51522],
    [39.116293, 1.512557],
    [39.110167, 1.515563],
    [39.110433, 1.513158],
    [39.114895, 1.512214],
    [39.114096, 1.505858],
    [39.110966, 1.505185],
    [39.102974, 1.505528],
    [39.100376, 1.49694],
    [39.110433, 1.493676],
    [39.110233, 1.483971],
    [39.101375, 1.482597],
    [39.106237, 1.477787],
    [39.104372, 1.469628],
    [39.100043, 1.469112],
    [39.100243, 1.467481],
    [39.104372, 1.464317],
    [39.077442, 1.381132],
    [39.064648, 1.376322],
    [39.065648, 1.367592],
    [39.077109, 1.365187],
    [39.073644, 1.353163],
    [39.066447, 1.341502],
    [39.054535, 1.340196],
    [39.056334, 1.332123],
    [39.031253, 1.285983],
    [38.975558, 1.273535],
    [38.976626, 1.230248],
    [39.000643, 1.211697],
    [38.988369, 1.200779],
    [38.853746, 1.211772],
    [38.863905, 1.231698],
    [38.85047, 1.246877],
    [38.858758, 1.258214],
    [38.875332, 1.269895],
    [38.868115, 1.296348],
    [38.860062, 1.295335],
    [38.859794, 1.307011],
    [38.865676, 1.314569],
    [38.862334, 1.320237],
    [38.854447, 1.317317],
    [38.854848, 1.322814],
    [38.861799, 1.325047],
    [38.861799, 1.327452],
    [38.865007, 1.352016],
    [38.842449, 1.367145],
    [38.830414, 1.366114],
    [38.82667, 1.377108],
    [38.836031, 1.391537],
    [38.742971, 1.416706],
    [38.726903, 1.376167],
    [38.643288, 1.37548],
    [38.632561, 1.383725],
    [38.633098, 1.40159],
    [38.680284, 1.459992],
    [38.64007, 1.542444],
    [38.642216, 1.581241],
    [38.66152, 1.59567],
    [38.696899, 1.566125],
    [38.678676, 1.526274],
    [38.701722, 1.4823],
    [38.715318, 1.48133],
    [38.729514, 1.471368],
    [38.733866, 1.451327],
    [38.846794, 1.410101],
    [38.895442, 1.424524],
    [38.889029, 1.458191],
  ],
  [
    [42.466019, 27.49514],
    [40.957086, 24.527203],
    [40.932709, 24.410426],
    [40.814329, 24.338968],
    [40.712394, 24.07567],
    [40.716298, 24.038985],
    [40.765201, 23.779263],
    [40.676733, 23.695438],
    [40.611476, 23.785081],
    [40.578107, 23.82081],
    [40.559852, 23.840049],
    [40.559787, 23.884502],
    [40.553624, 23.897953],
    [40.541216, 23.900299],
    [40.534188, 23.919599],
    [40.52176, 23.916411],
    [40.51654, 23.831145],
    [40.442897, 23.843513],
    [40.432968, 23.856568],
    [40.408921, 23.869622],
    [40.391143, 23.906725],
    [40.381205, 23.951386],
    [40.387482, 24.007041],
    [40.44551, 23.991925],
    [40.45276, 24.013645],
    [40.367735, 24.07095],
    [40.342619, 24.197375],
    [40.322532, 24.195564],
    [40.319915, 24.221673],
    [40.307938, 24.254929],
    [40.241405, 24.300965],
    [40.179529, 24.392902],
    [40.137547, 24.41008],
    [40.111295, 24.321444],
    [40.105649, 24.298513],
    [40.28005, 24.149551],
    [40.26538, 24.039616],
    [40.321944, 23.789514],
    [40.301, 23.715308],
    [40.248612, 23.751037],
    [40.150013, 23.926933],
    [40.108013, 24.001139],
    [39.994482, 24.025874],
    [39.939751, 24.012132],
    [39.929879, 23.942976],
    [40.019333, 23.832551],
    [39.999347, 23.828428],
    [40.068745, 23.781019],
    [40.216439, 23.654803],
    [40.221485, 23.577695],
    [40.259748, 23.448522],
    [40.272846, 23.395615],
    [40.197888, 23.332626],
    [40.139122, 23.395151],
    [40.104599, 23.452677],
    [40.058366, 23.465045],
    [40.019464, 23.537877],
    [39.981592, 23.665676],
    [39.961991, 23.692608],
    [39.934092, 23.695356],
    [39.934618, 23.74895],
    [39.914378, 23.753109],
    [39.90679, 23.716202],
    [39.908452, 23.69592],
    [39.915431, 23.678742],
    [39.911382, 23.643811],
    [39.919233, 23.592842],
    [39.930965, 23.576217],
    [39.93034, 23.558598],
    [39.967254, 23.449796],
    [39.955346, 23.41554],
    [39.95903, 23.381873],
    [39.95403, 23.355419],
    [39.996323, 23.378582],
    [40.078203, 23.3059],
    [40.236033, 23.278992],
    [40.28843, 23.018361],
    [40.369174, 22.880184],
    [40.465364, 22.848577],
    [40.479467, 22.806049],
    [40.509231, 22.82941],
    [40.51654, 22.941407],
    [40.632324, 22.918045],
    [40.544722, 22.75581],
    [40.49422, 22.738467],
    [40.498789, 22.708486],
    [40.520716, 22.678254],
    [40.489912, 22.667996],
    [40.47333, 22.669795],
    [40.449298, 22.610705],
    [39.68394, 22.902934],
    [38.747657, 20.88013],
    [38.718198, 20.556902],
    [38.223078, 20.330649],
    [39.651804, 19.61286],
    [40.676056, 19.129203],
    [41.799574, 19.228133],
    [42.640084, 18.127424],
    [42.660032, 18.152847],
    [42.677703, 18.151129],
    [42.691836, 18.133608],
    [42.691836, 18.084137],
    [42.663835, 18.060129],
    [42.659022, 18.05629],
    [42.648165, 18.061787],
    [42.710292, 17.326483],
    [42.863484, 16.622983],
    [43.175389, 16.271531],
    [43.324491, 16.407603],
    [43.332998, 16.40634],
    [43.340692, 16.407681],
    [43.392637, 16.428607],
    [43.493343, 16.526518],
    [43.503305, 16.529665],
    [43.530691, 16.521077],
    [43.53318, 16.478133],
    [43.538158, 16.446527],
    [43.51062, 16.385023],
    [43.51062, 16.385023],
    [43.487832, 16.394814],
    [43.330204, 16.401514],
    [43.319964, 16.388288],
    [43.392325, 15.884295],
    [44.043773, 14.75431],
    [44.836006, 14.095606],
    [44.719027, 13.886754],
    [45.115789, 13.502027],
    [45.503363, 13.474547],
    [45.63411, 13.724619],
    [45.733888, 13.62335],
    [45.661855, 13.464217],
    [45.608514, 13.09239],
    [45.637567, 12.999353],
    [45.804393, 12.710774],
    [45.844586, 12.490904],
    [45.835019, 12.004442],
    [45.6798, 11.614427],
    [45.404717, 11.688633],
    [45.302422, 12.136618],
    [45.225482, 12.244528],
    [45.252123, 12.317181],
    [44.91989, 12.574899],
    [44.686035, 12.316583],
    [44.154228, 12.548551],
    [43.606052, 13.646779],
    [42.53244, 14.220426],
    [42.012163, 15.033848],
    [41.936815, 15.713003],
    [41.923636, 16.206388],
    [41.777252, 16.227906],
    [41.543328, 15.947605],
    [40.367055, 18.450338],
    [40.037919, 18.590932],
    [39.768225, 18.371088],
    [39.873701, 17.947888],
    [40.235299, 17.837142],
    [40.231105, 17.507377],
    [40.352614, 16.990744],
    [39.793554, 16.551109],
    [39.687956, 16.562145],
    [39.666817, 16.814959],
    [39.361697, 17.238159],
    [38.922879, 17.227158],
    [38.841633, 17.117236],
    [38.897232, 16.91388],
    [38.721733, 16.606099],
    [38.421103, 16.612264],
    [38.13218, 16.244025],
    [37.88114, 16.084638],
    [37.895338, 15.663971],
    [38.012286, 15.620003],
    [38.224049, 15.630995],
    [38.293062, 15.787634],
    [38.53721, 15.887178],
    [38.615207, 15.797137],
    [38.731001, 15.971638],
    [38.724573, 16.111788],
    [38.90482, 16.194543],
    [38.936393, 16.125324],
    [39.484753, 15.92531],
    [39.538893, 15.850875],
    [40.041178, 15.606299],
    [40.049589, 15.507412],
    [39.971753, 15.435963],
    [40.003319, 15.251843],
    [40.152532, 15.111744],
    [40.148334, 15.023807],
    [40.246935, 14.87816],
    [40.36423, 14.979838],
    [40.648241, 14.763331],
    [40.62323, 14.69463],
    [40.625315, 14.623181],
    [40.573179, 14.54074],
    [40.60655, 14.477534],
    [40.543965, 14.326392],
    [40.524996, 14.192976],
    [40.562043, 14.18748],
    [40.562043, 14.18748],
    [40.701932, 14.463736],
    [40.830904, 14.275494],
    [40.786209, 14.20821],
    [40.788717, 14.154856],
    [40.812887, 14.159665],
    [40.813926, 14.117102],
    [40.826917, 14.104049],
    [40.82276, 14.079317],
    [40.791316, 14.090652],
    [40.777539, 14.090309],
    [40.776239, 14.082752],
    [40.785598, 14.075195],
    [40.628337, 13.924927],
    [40.724156, 13.809509],
    [40.819837, 13.985385],
    [41.213581, 13.633634],
    [41.16811, 13.556689],
    [41.230108, 13.193947],
    [41.192916, 13.040056],
    [41.41163, 12.671817],
    [41.399269, 12.61136],
    [41.993997, 11.825419],
    [42.364429, 11.349821],
    [42.303519, 10.899141],
    [42.370162, 10.833986],
    [42.483694, 11.184362],
    [42.76002, 10.747622],
    [42.695457, 10.374399],
    [42.741869, 10.06387],
    [42.822502, 10.157303],
    [43.083834, 10.492565],
    [43.478634, 10.251402],
    [43.990641, 10.004078],
    [43.991728, 9.85035],
    [44.333893, 9.246568],
    [44.347913, 9.249889],
    [44.489158, 9.186676],
    [44.587044, 9.153696],
    [44.635925, 9.022007],
    [44.563567, 8.793892],
    [44.432309, 8.736176],
    [44.4, 8.7],
    [43.85394, 8.097287],
    [43.150897, 6.647324],
    [42.958232, 6.257101],
    [43.165623, 5.599867],
    [43.425497, 5.610861],
    [43.509219, 5.514667],
    [43.837003, 5.410229],
    [43.959708, 5.096703],
    [44.009608, 4.805361],
    [43.469827, 4.299727],
    [43.462688, 3.915764],
    [42.97431, 3.085853],
    [42.402773, 3.260623],
    [42.311643, 3.322364],
    [42.218144, 3.267403],
    [42.169307, 3.179466],
    [41.891851, 3.278395],
    [41.395149, 2.27261],
    [41.275536, 2.206657],
    [40.969322, 0.931562],
    [40.79489, 0.799656],
    [40.711666, 0.931562],
    [40.574118, 0.799656],
    [40.528205, 0.552332],
    [39.43386, -0.266587],
    [40.473905, -2.614702],
    [41.750414, -2.460198],
    [41.391028, -3.730266],
    [40.72145, -5.226607],
    [40.484142, -5.429228],
    [39.833007, -7.498646],
    [39.877916, -8.988506],
    [40.184959, -8.931618],
    [41.025085, -8.678261],
    [41.676605, -8.908428],
    [42.112283, -8.914379],
    [42.918017, -9.332082],
    [43.166926, -9.255137],
    [43.251004, -9.030363],
    [43.386886, -8.870976],
    [43.306993, -8.733574],
    [43.358936, -8.508234],
    [43.463784, -8.349243],
    [43.476205, -8.342376],
    [43.498125, -8.321422],
    [43.506287, -8.332772],
    [43.510645, -8.340673],
    [43.511879, -8.339909],
    [43.512999, -8.329646],
    [43.525831, -8.324007],
    [43.525741, -8.317838],
    [43.526878, -8.317245],
    [43.527687, -8.311453],
    [43.524358, -8.310465],
    [43.524482, -8.306515],
    [43.528417, -8.300152],
    [43.536243, -8.296899],
    [43.541408, -8.300249],
    [43.542465, -8.303598],
    [43.544083, -8.303858],
    [43.54542, -8.302699],
    [43.547007, -8.303772],
    [43.546789, -8.306091],
    [43.545358, -8.308367],
    [43.545514, -8.31296],
    [43.549882, -8.315526],
    [43.550878, -8.313293],
    [43.551758, -8.328185],
    [43.567569, -8.322759],
    [43.569559, -8.306615],
    [43.558862, -8.296996],
    [43.556622, -8.265394],
    [43.582741, -8.218677],
    [43.585641, -8.220489],
    [43.592977, -8.216882],
    [43.595899, -8.203399],
    [43.600561, -8.199964],
    [43.60325, -8.201488],
    [43.603654, -8.200586],
    [43.602877, -8.199341],
    [43.6044, -8.19947],
    [43.60381, -8.19728],
    [43.604276, -8.196163],
    [43.601603, -8.192685],
    [43.60757, -8.191913],
    [43.607818, -8.193415],
    [43.609745, -8.193802],
    [43.608782, -8.196053],
    [43.609117, -8.196979],
    [43.610304, -8.198717],
    [43.612479, -8.198588],
    [43.612759, -8.193822],
    [43.613567, -8.192104],
    [43.612976, -8.190515],
    [43.615742, -8.189141],
    [43.618476, -8.190258],
    [43.62006, -8.18953],
    [43.621614, -8.187426],
    [43.621645, -8.184464],
    [43.620682, -8.184206],
    [43.620799, -8.18318],
    [43.621576, -8.182665],
    [43.62215, -8.18157],
    [43.62229, -8.180389],
    [43.620877, -8.18011],
    [43.620923, -8.180711],
    [43.61394, -8.18137],
    [43.611831, -8.169684],
    [43.617051, -8.153196],
    [43.634696, -8.140486],
    [43.636628, -8.127628],
    [43.644082, -8.122476],
    [43.63961, -8.116808],
    [43.640852, -8.110797],
    [43.647187, -8.113716],
    [43.649423, -8.106674],
    [43.645358, -8.103429],
    [43.64778, -8.100939],
    [43.649581, -8.103343],
    [43.652997, -8.101626],
    [43.652935, -8.096044],
    [43.654598, -8.094681],
    [43.654411, -8.096703],
    [43.655188, -8.097004],
    [43.655367, -8.095804],
    [43.656003, -8.097199],
    [43.656795, -8.096985],
    [43.658503, -8.095439],
    [43.658612, -8.093979],
    [43.707048, -8.070485],
    [43.712011, -8.004532],
    [43.726899, -7.959189],
    [43.739799, -7.955067],
    [43.740791, -7.922091],
    [43.77154, -7.90835],
    [43.768565, -7.886366],
    [43.77154, -7.857512],
    [43.709033, -7.846519],
    [43.786413, -7.694003],
    [43.78443, -7.658278],
    [43.736822, -7.673392],
    [43.753688, -7.633546],
    [43.686197, -7.592325],
    [43.714269, -7.58714],
    [43.713773, -7.559659],
    [43.730533, -7.556034],
    [43.733622, -7.543194],
    [43.736983, -7.527541],
    [43.733014, -7.514831],
    [43.724647, -7.513024],
    [43.728369, -7.508559],
    [43.723531, -7.503406],
    [43.728301, -7.491086],
    [43.723587, -7.46704],
    [43.702853, -7.453062],
    [43.670082, -7.354819],
    [43.576859, -7.242529],
    [43.55972, -7.154034],
    [43.561387, -6.48645],
    [43.575864, -6.462202],
    [43.593223, -6.266508],
    [43.592775, -6.224537],
    [43.561934, -6.122859],
    [43.574869, -6.04454],
    [43.594764, -6.018434],
    [43.585812, -5.946984],
    [43.662358, -5.853537],
    [43.628571, -5.773843],
    [43.571885, -5.709264],
    [43.553973, -5.412475],
    [43.529534, -5.268525],
    [43.483716, -5.197076],
    [43.405945, -4.633194],
    [43.405945, -4.330908],
    [43.499657, -3.806031],
    [43.473751, -3.748322],
    [43.519576, -3.599927],
    [43.461791, -3.415808],
    [43.418465, -3.433206],
    [43.41647, -3.314946],
    [43.391527, -3.211878],
    [43.351596, -3.125315],
    [43.377467, -3.082606],
    [43.354367, -3.037529],
    [43.375832, -3.036842],
    [43.435196, -2.944782],
    [43.434423, -2.807842],
    [43.44766, -2.788893],
    [43.459623, -2.754543],
    [43.431207, -2.731184],
    [43.403775, -2.687903],
    [43.415248, -2.674162],
    [43.415248, -2.637064],
    [43.395793, -2.622637],
    [43.393298, -2.567676],
    [43.377829, -2.544317],
    [43.37733, -2.505844],
    [43.340386, -2.455693],
    [43.300921, -2.348519],
    [43.298423, -2.280504],
    [43.312414, -2.227605],
    [43.307917, -2.203559],
    [43.288427, -2.16646],
    [43.322792, -2.023124],
    [43.323542, -2.001846],
    [43.329036, -1.976083],
    [43.335848, -1.973034],
    [43.338844, -1.961527],
    [43.333725, -1.945725],
    [43.336472, -1.927176],
    [43.34234, -1.902615],
    [43.350704, -1.884409],
    [43.375333, -1.860379],
    [43.39729, -1.793051],
    [43.378827, -1.760762],
    [43.419737, -1.631604],
    [43.630559, -1.462697],
    [44.486513, -1.269282],
    [45.423323, -1.186841],
    [45.93759, -1.434165],
    [46.049313, -1.420193],
    [45.94819, -1.189357],
    [45.869836, -1.145388],
    [46.112182, -1.164624],
    [46.178784, -1.521871],
    [46.256701, -1.57958],
    [46.169275, -1.227829],
    [46.2586, -1.134396],
    [46.321232, -1.442177],
    [46.470876, -1.829652],
    [46.704933, -2.019267],
    [46.800906, -2.164034],
    [46.947356, -2.221743],
    [46.947356, -2.262964],
    [46.979222, -2.320673],
    [47.034988, -2.311103],
    [47.011583, -2.212173],
    [46.911297, -2.122862],
    [47.03218, -2.004695],
    [47.124765, -2.260264],
    [47.230247, -2.213522],
    [47.233044, -2.447106],
    [47.283794, -2.581453],
    [47.374593, -2.572035],
    [47.422931, -2.488219],
    [47.465909, -2.51578],
    [47.503623, -2.495221],
    [47.794338, -2.140762],
    [47.833255, -1.130419],
    [47.87546, -0.832961],
    [47.550209, -0.063507],
    [47.006105, 0.508087],
    [46.98, 0.3],
    [46.92, 0.2],
    [46.886102, -0.690215],
    [46.114753, 0.244122],
    [45.58675, 0.870677],
    [45.432768, 1.794021],
    [45.432768, 2.706373],
    [45.579061, 3.684678],
    [46.190859, 4.454132],
    [47.318159, 4.885924],
    [47.718817, 5.452022],
    [47.844317, 5.770796],
    [47.807436, 6.259948],
    [47.426043, 6.628187],
    [46.743249, 8.308016],
    [46.312411, 9.473188],
    [46.274455, 10.187681],
    [46.335172, 10.5834],
    [46.916128, 10.748283],
    [47.35706, 11.023088],
    [47.312386, 11.638651],
    [47.537627, 15.52704],
    [47.142843, 16.118808],
    [45.816667, 18],
    [45.084769, 19.932108],
    [44.976068, 20.360804],
    [45.162287, 20.646601],
    [45.270634, 21.053312],
    [45.394207, 21.503992],
    [44.472207, 24.655397],
    [44.14201, 26.150335],
    [43.663501, 28.599447],
    [43.464482, 28.6654],
    [43.280805, 28.467541],
    [43.272806, 28.115791],
    [42.680214, 27.955554],
    [42.482023, 27.532293],
  ],
  [
    [49.399736, -0.929258],
    [49.373163, -0.855081],
    [49.337383, -0.058147],
    [49.435717, 0.131541],
    [49.501758, 0.029863],
    [49.695795, 0.1562],
    [49.876672, 0.645353],
    [50.048057, 1.285648],
    [50.271524, 1.445186],
    [50.512379, 1.560317],
    [50.323371, 1.912067],
    [49.992556, 3.000294],
    [49.502739, 3.549904],
    [49.159077, 4.13249],
    [48.813013, 4.386929],
    [48.377051, 4.298992],
    [48.054952, 3.63946],
    [47.9226, 2.727108],
    [48.018222, 1.715826],
    [48.223575, 0.594622],
    [48.479112, -0.251776],
    [48.715793, -0.774299],
    [48.921958, -0.999639],
    [49.397122, -1.062643],
  ],
  [
    [49.687, 33.4389],
    [50.214437, 33.590698],
    [51.657, 34.745],
    [53.2, 37.71],
    [54.6, 41.74],
    [57.2, 47],
    [57.6, 48.7],
    [57.4099, 50.7277],
    [56.2, 55.5],
    [55.362566, 49.328613],
  ],
  [
    [50.591694, -4.905874],
    [50.514911, -4.762264],
    [50.439752, -4.699059],
    [50.309888, -4.667723],
    [50.323294, -4.642738],
    [50.320006, -4.607357],
    [50.320006, -4.59293],
    [50.325486, -4.572663],
    [50.318219, -4.53103],
    [50.328302, -4.493931],
    [50.32611, -4.465764],
    [50.331842, -4.439869],
    [50.34718, -4.445709],
    [50.34718, -4.445709],
    [50.355286, -4.362237],
    [50.355724, -4.298688],
    [50.325705, -4.226209],
    [50.318691, -4.23514],
    [50.307071, -4.229644],
    [50.307509, -4.218995],
    [50.314322, -4.216501],
    [50.316515, -4.189364],
    [50.317016, -4.186377],
    [50.325456, -4.188794],
    [50.331154, -4.199013],
    [50.341171, -4.169113],
    [50.347643, -4.163635],
    [50.355365, -4.170084],
    [50.353668, -4.154454],
    [50.35301, -4.148438],
    [50.357337, -4.137704],
    [50.353722, -4.127656],
    [50.348958, -4.123191],
    [50.345397, -4.126368],
    [50.34348, -4.129115],
    [50.335647, -4.128685],
    [50.335537, -4.127397],
    [50.335921, -4.1213],
    [50.335428, -4.121214],
    [50.333816, -4.121529],
    [50.329434, -4.121578],
    [50.327805, -4.122531],
    [50.323668, -4.12266],
    [50.323038, -4.120427],
    [50.321086, -4.121352],
    [50.319065, -4.119566],
    [50.318544, -4.113898],
    [50.315995, -4.113039],
    [50.31457, -4.105482],
    [50.314762, -4.104151],
    [50.316633, -4.101798],
    [50.315843, -4.09042],
    [50.316428, -4.087747],
    [50.317524, -4.084786],
    [50.316551, -4.083219],
    [50.316318, -4.081866],
    [50.315948, -4.080299],
    [50.315839, -4.078968],
    [50.315797, -4.077873],
    [50.316058, -4.077293],
    [50.31468, -4.074679],
    [50.314212, -4.072043],
    [50.311885, -4.069999],
    [50.309911, -4.06901],
    [50.308596, -4.074205],
    [50.303087, -4.076996],
    [50.300537, -4.064759],
    [50.295725, -4.056349],
    [50.293038, -4.050166],
    [50.290845, -4.038658],
    [50.293641, -4.025691],
    [50.293477, -4.020367],
    [50.296124, -4.017119],
    [50.300318, -4.016045],
    [50.302429, -4.010259],
    [50.300894, -4.005579],
    [50.303662, -3.997123],
    [50.306677, -3.9924],
    [50.305691, -3.986045],
    [50.256623, -3.870141],
    [50.244181, -3.863459],
    [50.242095, -3.874794],
    [50.231713, -3.863032],
    [50.212383, -3.812193],
    [50.212663, -3.801404],
    [50.210136, -3.797969],
    [50.208379, -3.785946],
    [50.210331, -3.783649],
    [50.214506, -3.785194],
    [50.214835, -3.779612],
    [50.213103, -3.739225],
    [50.205962, -3.732871],
    [50.205882, -3.727329],
    [50.201048, -3.724238],
    [50.201557, -3.718935],
    [50.204524, -3.716187],
    [50.205155, -3.710605],
    [50.204441, -3.70863],
    [50.207435, -3.703459],
    [50.210923, -3.702603],
    [50.212818, -3.696634],
    [50.215629, -3.686761],
    [50.219474, -3.660482],
    [50.216398, -3.657906],
    [50.216923, -3.653799],
    [50.220328, -3.64899],
    [50.220163, -3.639629],
    [50.223238, -3.638427],
    [50.225422, -3.650073],
    [50.23913, -3.657396],
    [50.290973, -3.639528],
    [50.315314, -3.607269],
    [50.322549, -3.572231],
    [50.332192, -3.566048],
    [50.335041, -3.546125],
    [50.334115, -3.541685],
    [50.337452, -3.529305],
    [50.35033, -3.513704],
    [50.398211, -3.477794],
    [50.402708, -3.486752],
    [50.408397, -3.550644],
    [50.456728, -3.5345],
    [50.44711, -3.514889],
    [50.458914, -3.475386],
    [50.468748, -3.479506],
    [50.481858, -3.510079],
    [50.532395, -3.493573],
    [50.562839, -3.466833],
    [50.576576, -3.463398],
    [50.59031, -3.441414],
    [50.595601, -3.44024],
    [50.614558, -3.418599],
    [50.608397, -3.408438],
    [50.60404, -3.384104],
    [50.607308, -3.365555],
    [50.60404, -3.359715],
    [50.605565, -3.353188],
    [50.614715, -3.355249],
    [50.626913, -3.30924],
    [50.624082, -3.305118],
    [50.647817, -3.27836],
    [50.651735, -3.281451],
    [50.653754, -3.278032],
    [50.668445, -3.262403],
    [50.680558, -3.098],
    [50.685414, -3.092611],
    [50.700203, -3.081962],
    [50.695033, -3.024965],
    [50.697159, -3.004918],
    [50.703791, -2.994098],
    [50.703139, -2.982418],
    [50.71151, -2.953907],
    [50.716401, -2.939137],
    [50.71814, -2.931408],
    [50.730528, -2.917324],
    [50.717091, -2.841262],
    [50.701198, -2.761458],
    [50.561825, -2.470165],
    [50.558335, -2.463295],
    [50.51144, -2.464296],
    [50.510032, -2.453692],
    [50.517018, -2.442357],
    [50.534915, -2.426555],
    [50.539934, -2.413184],
    [50.552151, -2.412154],
    [50.571125, -2.425879],
    [50.572652, -2.458855],
    [50.585515, -2.465038],
    [50.603604, -2.44168],
    [50.612755, -2.443397],
    [50.63214, -2.419362],
    [50.626913, -2.363027],
    [50.628874, -2.337997],
    [50.62125, -2.327348],
    [50.610021, -2.223194],
    [50.618419, -2.203702],
    [50.612319, -2.188244],
    [50.609051, -2.151146],
    [50.594451, -2.107864],
    [50.589438, -2.068473],
    [50.572434, -2.060229],
    [50.571998, -2.054046],
    [50.578926, -2.033306],
    [50.586882, -2.026092],
    [50.586049, -1.954109],
    [50.610892, -1.93764],
    [50.64281, -1.916036],
    [50.646293, -1.94489],
    [50.694479, -1.919089],
    [50.709167, -1.75704],
    [50.711341, -1.742269],
    [50.730251, -1.727155],
    [50.7097, -1.574302],
    [50.698393, -1.545436],
    [50.716558, -1.543211],
    [50.769666, -1.399238],
    [50.779653, -1.338781],
    [50.805381, -1.315518],
    [50.808853, -1.300453],
    [50.830109, -1.284995],
    [50.768125, -1.15184],
    [50.77022, -1.134241],
    [50.786285, -1.110195],
    [50.774128, -1.086493],
    [50.784765, -1.025693],
    [50.777167, -0.966415],
    [50.773694, -0.947524],
    [50.766746, -0.888098],
    [50.717961, -0.790824],
    [50.721183, -0.782559],
    [50.759362, -0.743517],
    [50.770605, -0.721255],
    [50.785731, -0.606201],
    [50.799957, -0.474368],
    [50.799621, -0.425541],
    [50.799621, -0.364538],
    [50.820447, -0.272478],
    [50.799187, -0.071277],
    [50.768125, 0.055319],
    [50.722742, 0.25021],
    [50.772272, 0.316655],
    [50.812638, 0.373606],
    [50.860101, 0.667785],
    [50.926172, 0.793317],
    [50.906692, 0.990954],
    [50.995521, 0.989073],
    [51.137054, 1.434257],
    [51.317503, 1.381594],
    [51.31555, 1.451841],
    [51.403018, 1.469703],
    [51.366165, 0.96823],
    [51.426144, 0.918765],
    [51.496304, 0.554687],
    [51.508935, 0.803443],
    [51.621811, 0.982193],
    [51.634406, 0.946996],
    [51.762273, 0.969786],
    [51.758873, 1.05635],
    [51.764823, 1.127799],
    [51.802013, 1.216832],
    [51.830877, 1.264923],
    [51.870651, 1.297817],
    [51.893116, 1.249726],
    [51.933777, 1.290604],
    [51.951084, 1.295555],
    [51.948265, 1.089073],
    [51.930253, 0.87771],
    [51.605907, -0.088067],
    [51.646828, -0.445313],
    [51.906663, -1.111103],
    [52.03526, -1.517814],
    [52.042018, -1.924525],
    [51.960854, -2.188338],
    [51.552825, -2.781916],
    [51.306236, -3.034737],
    [51.218755, -3.181395],
    [51.194664, -3.362767],
    [51.256587, -3.571618],
    [51.211873, -4.245717],
    [51.011854, -4.322663],
    [51.018765, -4.591971],
    [50.776245, -4.641193],
    [50.654511, -4.82806],
    [50.623156, -4.82806],
  ],
  [
    [54.009564, -6.388532],
    [53.971799, -6.543666],
    [53.835066, -6.740152],
    [53.613529, -6.876855],
    [53.131777, -7.063722],
    [52.827495, -7.041738],
    [52.666056, -6.953325],
    [52.519229, -6.755466],
    [52.447473, -6.278024],
    [52.565416, -6.171348],
    [52.627145, -6.215317],
    [52.735377, -6.130128],
    [52.797136, -6.130988],
    [52.85688, -6.045799],
    [52.964543, -5.992217],
    [52.996789, -6.040308],
    [53.067173, -6.017594],
    [53.259833, -6.097285],
    [53.269412, -6.07712],
    [53.294249, -6.12071],
    [53.303893, -6.125863],
    [53.298353, -6.15403],
    [53.315995, -6.201778],
    [53.33281, -6.20693],
    [53.335066, -6.17945],
    [53.371542, -6.107637],
    [53.357201, -6.079869],
    [53.360889, -6.059602],
    [53.359511, -6.051208],
    [53.360615, -6.049161],
    [53.365737, -6.05251],
    [53.377538, -6.042788],
    [53.385655, -6.043579],
    [53.386986, -6.060931],
    [53.392924, -6.062391],
    [53.394068, -6.06784],
    [53.398367, -6.10013],
    [53.432334, -6.116957],
    [53.461778, -6.121079],
    [53.486708, -6.095651],
    [53.516318, -6.090842],
    [53.515659, -6.081938],
    [53.521375, -6.073866],
    [53.530197, -6.082256],
    [53.539991, -6.074012],
    [53.561, -6.082599],
    [53.567118, -6.096342],
    [53.581388, -6.101151],
    [53.58458, -6.098517],
    [53.58562, -6.099082],
    [53.585791, -6.108053],
    [53.583663, -6.106503],
    [53.605228, -6.161925],
    [53.608713, -6.164443],
    [53.779112, -6.225118],
    [53.794861, -6.211697],
    [53.810747, -6.244105],
    [53.855544, -6.235996],
    [53.864362, -6.234344],
    [53.880105, -6.30357],
    [53.88784, -6.342879],
    [53.9293, -6.369291],
    [54.005126, -6.329414],
  ],
];

const coordinates_1349 = [
  [
    [54.414335, -4.353803],
    [54.393552, -4.352428],
    [54.344751, -4.373041],
    [54.317525, -4.370293],
    [54.313018, -4.3591],
    [54.301401, -4.302071],
    [54.290982, -4.305506],
    [54.20465, -4.388582],
    [54.196617, -4.384803],
    [54.189687, -4.38944],
    [54.168564, -4.408509],
    [54.15771, -4.466225],
    [54.150874, -4.472408],
    [54.141222, -4.460041],
    [54.121508, -4.499205],
    [54.121105, -4.519131],
    [54.099369, -4.540431],
    [54.094537, -4.577534],
    [54.076815, -4.613185],
    [54.073617, -4.619146],
    [54.071703, -4.614165],
    [54.076236, -4.606778],
    [54.074222, -4.601797],
    [54.052863, -4.62241],
    [54.05367, -4.628078],
    [54.053871, -4.633747],
    [54.055046, -4.63373],
    [54.056091, -4.62819],
    [54.067775, -4.623914],
    [54.074927, -4.631987],
    [54.074927, -4.647447],
    [54.071401, -4.647619],
    [54.067271, -4.661532],
    [54.063242, -4.660674],
    [54.060824, -4.664453],
    [54.060924, -4.675103],
    [54.062436, -4.678366],
    [54.069374, -4.68554],
    [54.071238, -4.684325],
    [54.072195, -4.685956],
    [54.077784, -4.689392],
    [54.077784, -4.693171],
    [54.082014, -4.693335],
    [54.081372, -4.726782],
    [54.076941, -4.728156],
    [54.077199, -4.734187],
    [54.078181, -4.735046],
    [54.077275, -4.737193],
    [54.074807, -4.73612],
    [54.073749, -4.73689],
    [54.073548, -4.735172],
    [54.072415, -4.735301],
    [54.070775, -4.733101],
    [54.072289, -4.730404],
    [54.071936, -4.729674],
    [54.070526, -4.732079],
    [54.06967, -4.731348],
    [54.069569, -4.733453],
    [54.068965, -4.73444],
    [54.068335, -4.732551],
    [54.067907, -4.733324],
    [54.067832, -4.735557],
    [54.067227, -4.735986],
    [54.066925, -4.742385],
    [54.069292, -4.744146],
    [54.069947, -4.748053],
    [54.06831, -4.748826],
    [54.067832, -4.750158],
    [54.067555, -4.750287],
    [54.067429, -4.749599],
    [54.064583, -4.749728],
    [54.063777, -4.752949],
    [54.061812, -4.752305],
    [54.058229, -4.760968],
    [54.05964, -4.768869],
    [54.054803, -4.768526],
    [54.053796, -4.784673],
    [54.058028, -4.786734],
    [54.058028, -4.794292],
    [54.039887, -4.811126],
    [54.043188, -4.819112],
    [54.043087, -4.828044],
    [54.054778, -4.833713],
    [54.059816, -4.822032],
    [54.060521, -4.812756],
    [54.062133, -4.80829],
    [54.063846, -4.795407],
    [54.06848, -4.792487],
    [54.068417, -4.790919],
    [54.069979, -4.78903],
    [54.072698, -4.789117],
    [54.075015, -4.78594],
    [54.076928, -4.779154],
    [54.085337, -4.770995],
    [54.085035, -4.762063],
    [54.087401, -4.760705],
    [54.090069, -4.767318],
    [54.089818, -4.779686],
    [54.096361, -4.781575],
    [54.10805, -4.766905],
    [54.109698, -4.754093],
    [54.107333, -4.75289],
    [54.107578, -4.75147],
    [54.109037, -4.751341],
    [54.119722, -4.747679],
    [54.126965, -4.738575],
    [54.131793, -4.739434],
    [54.13461, -4.734281],
    [54.14356, -4.732735],
    [54.146161, -4.736252],
    [54.154908, -4.732731],
    [54.155863, -4.734363],
    [54.161994, -4.741749],
    [54.161693, -4.744755],
    [54.162497, -4.746044],
    [54.163904, -4.743639],
    [54.173601, -4.744068],
    [54.178776, -4.729639],
    [54.17978, -4.7317],
    [54.191822, -4.721783],
    [54.197646, -4.721439],
    [54.200056, -4.716286],
    [54.212305, -4.722126],
    [54.215517, -4.715942],
    [54.222543, -4.710487],
    [54.227561, -4.700524],
    [54.226959, -4.695027],
    [54.226357, -4.688156],
    [54.23037, -4.680598],
    [54.269435, -4.614481],
    [54.370359, -4.55814],
    [54.39675, -4.478437],
    [54.402196, -4.459416],
    [54.420378, -4.355733],
  ],
  [
    [56.287431, 12.370405],
    [59.088278, 10.569141],
    [58.963889, 10.272736],
    [58.864336, 9.88896],
    [58.533287, 9.208087],
    [58.14114, 8.68096],
    [57.955092, 7.978124],
    [57.87339, 7.187434],
    [57.948679, 6.550759],
    [58.549914, 5.452578],
    [58.89216, 5.276869],
    [59.073319, 5.013305],
    [60.940039, 4.486178],
    [61.406185, 4.530106],
    [61.844746, 4.661887],
    [62.33839, 5.452578],
    [62.783883, 6.37505],
    [63.138971, 7.537651],
    [63.435282, 7.493723],
    [63.854711, 8.679759],
    [63.67989, 9.360632],
    [63.980299, 9.646159],
    [64.391715, 10.327031],
    [64.677734, 11.063133],
    [64.673034, 13.424223],
    [64.432284, 14.840877],
    [63.845027, 13.158912],
    [63.346709, 12.807494],
    [62.597892, 13.158912],
    [61.105567, 13.578731],
    [60.227812, 12.913817],
    [59.231052, 12.342763],
    [58.526978, 12.167054],
    [57.218419, 13.221308],
    [55.958119, 13.40221],
    [55.683479, 13.053786],
  ],
  [
    [51.714182, -4.39771],
    [51.63952, -4.253196],
    [51.611073, -4.317932],
    [51.607405, -4.317991],
    [51.606765, -4.30924],
    [51.57061, -4.294118],
    [51.567302, -4.333756],
    [51.563722, -4.336836],
    [51.553551, -4.316233],
    [51.533192, -4.213612],
    [51.533833, -4.199199],
    [51.543655, -4.193364],
    [51.537986, -4.147407],
    [51.542449, -4.13787],
    [51.556113, -4.146106],
    [51.562089, -4.118652],
    [51.550989, -4.07747],
    [51.561374, -3.975028],
    [51.565488, -3.966945],
    [51.573752, -3.987041],
    [51.585134, -3.983993],
    [51.607314, -3.860448],
    [51.466178, -3.721635],
    [51.467462, -3.659862],
    [51.391408, -3.590023],
    [51.363978, -3.375878],
    [51.38798, -3.153496],
    [51.466756, -3.126042],
    [51.552825, -2.781916],
    [51.960854, -2.188338],
    [52.042018, -1.924525],
    [52.03526, -1.517814],
    [51.906663, -1.111103],
    [51.646828, -0.445313],
    [51.605907, -0.088067],
    [51.930253, 0.87771],
    [51.948265, 1.089073],
    [51.951084, 1.295555],
    [51.928061, 1.320019],
    [51.954517, 1.350219],
    [51.960864, 1.373556],
    [51.984552, 1.399637],
    [52.006537, 1.438136],
    [52.028511, 1.45255],
    [52.03527, 1.464218],
    [52.046251, 1.478632],
    [52.082977, 1.582959],
    [52.08804, 1.58576],
    [52.184647, 1.624517],
    [52.267695, 1.639546],
    [52.310042, 1.670913],
    [52.31445, 1.679836],
    [52.413498, 1.737144],
    [52.437783, 1.736458],
    [52.477114, 1.771462],
    [52.553999, 1.740576],
    [52.579782, 1.747476],
    [52.632, 1.753613],
    [52.754955, 1.689032],
    [52.932831, 1.326422],
    [52.984121, 0.980495],
    [52.995694, 0.544063],
    [52.869876, 0.371099],
    [52.939452, 0.151463],
    [53.119499, 0.406297],
    [53.493683, 0.192151],
    [53.576934, -0.038467],
    [53.629086, 0.010951],
    [53.565517, 0.172933],
    [53.651882, 0.153715],
    [53.888882, -0.126321],
    [54.064949, -0.183976],
    [54.100395, -0.043958],
    [54.128429, -0.068766],
    [54.175879, -0.255457],
    [54.213951, -0.277409],
    [54.212747, -0.255119],
    [54.217319, -0.256137],
    [54.230411, -0.308663],
    [54.238527, -0.328304],
    [54.243453, -0.34028],
    [54.242851, -0.349546],
    [54.248668, -0.364989],
    [54.253939, -0.364627],
    [54.274537, -0.392096],
    [54.285817, -0.382303],
    [54.291328, -0.385737],
    [54.290025, -0.396719],
    [54.301546, -0.4077],
    [54.305653, -0.405641],
    [54.334323, -0.414061],
    [54.407522, -0.479952],
    [54.418311, -0.520448],
    [54.432801, -0.526643],
    [54.442386, -0.516347],
    [54.448175, -0.522231],
    [54.481568, -0.572811],
    [54.489366, -0.591281],
    [54.504918, -0.663349],
    [54.52157, -0.678429],
    [54.534321, -0.711718],
    [54.556496, -0.770577],
    [54.658661, -1.173007],
    [54.700999, -1.170762],
    [54.770157, -1.293785],
    [54.927852, -1.348829],
    [54.962025, -1.34592],
    [54.999852, -1.39877],
    [55.160749, -1.510893],
    [55.185817, -1.492098],
    [55.290416, -1.546439],
    [55.320052, -1.540538],
    [55.367757, -1.590489],
    [55.40676, -1.557543],
    [55.577491, -1.607068],
    [55.642647, -1.749831],
    [55.687224, -1.767591],
    [55.729778, -1.946046],
    [55.914505, -2.114975],
    [55.581139, -2.758652],
    [55.537646, -3.263815],
    [55.288188, -3.296761],
    [55.200505, -3.538361],
    [55.169143, -3.922724],
    [55.030856, -4.186288],
    [54.917356, -4.109415],
    [54.803535, -3.790942],
    [54.905751, -3.477355],
    [54.882058, -3.425191],
    [54.509762, -3.669698],
    [54.05439, -3.345734],
    [53.999536, -3.181007],
    [54.134926, -3.032753],
    [54.105951, -2.873516],
    [53.934909, -3.098643],
    [53.420827, -3.164534],
    [53.30938, -3.713695],
    [53.34801, -3.85636],
    [53.328782, -3.902962],
    [53.295142, -3.870016],
    [53.245043, -4.064944],
    [53.312375, -4.008662],
    [53.320579, -4.125344],
    [53.298425, -4.181625],
    [53.417267, -4.279089],
    [53.431179, -4.427477],
    [53.406626, -4.590831],
    [53.309093, -4.586713],
    [53.326321, -4.692413],
    [53.281186, -4.708886],
    [53.268868, -4.640249],
    [53.23929, -4.63064],
    [53.223672, -4.541413],
    [53.174601, -4.526681],
    [53.082312, -4.389408],
    [53.03279, -4.405881],
    [52.814217, -4.845154],
    [52.741114, -4.713379],
    [52.787649, -4.60356],
    [52.754415, -4.532179],
    [52.775272, -4.45796],
    [52.857896, -4.445472],
    [52.895193, -4.199754],
    [52.632146, -4.150427],
    [52.4791, -4.088133],
    [52.311501, -4.186969],
    [51.967623, -5.34006],
    [51.621086, -5.285151],
    [51.568364, -5.01024],
    [51.554704, -4.894931],
    [51.602495, -4.735706],
  ],
  [
    [52.348532, -6.385166],
    [52.35063, -6.440761],
    [52.309927, -6.440761],
    [52.312866, -6.387396],
    [52.25784, -6.360628],
    [52.262043, -6.334546],
    [52.239763, -6.309837],
    [52.165277, -6.35651],
    [52.182963, -6.49996],
    [52.165698, -6.59811],
    [52.211583, -6.698319],
    [52.202326, -6.78686],
    [52.207796, -6.815],
    [52.172016, -6.82255],
    [52.16991, -6.839023],
    [52.159286, -6.877158],
    [52.127682, -6.904956],
    [52.118829, -6.932067],
    [52.131475, -6.94202],
    [52.157179, -6.902213],
    [52.188973, -6.919716],
    [52.197391, -6.912166],
    [52.219482, -6.940993],
    [52.237777, -6.965016],
    [52.207864, -6.969132],
    [52.195555, -6.980114],
    [52.187347, -6.980972],
    [52.185663, -6.973765],
    [52.183955, -6.971863],
    [52.182482, -6.973922],
    [52.178377, -6.968775],
    [52.180312, -6.949205],
    [52.17676, -6.948476],
    [52.171166, -6.970578],
    [52.162268, -6.972895],
    [52.15829, -6.982686],
    [52.143966, -6.98734],
    [52.13048, -7.03264],
    [52.133009, -7.037445],
    [52.132376, -7.083638],
    [52.123888, -7.092761],
    [52.125996, -7.113695],
    [52.14138, -7.101341],
    [52.153177, -7.152818],
    [52.122064, -7.181041],
    [52.124404, -7.395921],
    [52.127355, -7.402099],
    [52.099699, -7.497177],
    [52.102593, -7.507173],
    [52.094579, -7.540461],
    [52.074959, -7.548011],
    [52.080656, -7.575809],
    [52.091415, -7.579241],
    [52.08593, -7.605322],
    [52.052327, -7.586577],
    [52.055705, -7.537502],
    [52.050474, -7.531172],
    [52.034003, -7.569265],
    [51.992645, -7.580079],
    [51.975766, -7.589617],
    [51.967845, -7.703855],
    [51.950074, -7.706258],
    [51.942879, -7.701798],
    [51.930253, -7.719417],
    [51.935143, -7.837506],
    [51.899567, -7.895847],
    [51.888126, -7.864274],
    [51.876258, -7.860292],
    [51.852513, -7.999623],
    [51.835968, -8.014723],
    [51.821116, -7.98521],
    [51.80456, -8.059337],
    [51.799465, -8.132091],
    [51.776529, -8.170528],
    [51.787998, -8.186314],
    [51.787574, -8.25495],
    [51.727645, -8.304373],
    [51.706991, -8.351133],
    [51.651568, -8.530914],
    [51.610011, -8.521003],
    [51.602548, -8.532671],
    [51.60499, -8.544743],
    [51.625882, -8.562588],
    [51.632702, -8.675152],
    [51.576408, -8.690252],
    [51.567446, -8.704062],
    [51.562324, -8.744558],
    [51.587928, -8.848198],
    [51.574984, -8.867023],
    [51.569116, -8.889501],
    [51.552378, -8.888251],
    [51.549562, -8.89062],
    [51.551323, -8.896626],
    [51.546359, -8.897312],
    [51.545452, -8.90246],
    [51.546626, -8.904176],
    [51.542623, -8.907093],
    [51.541288, -8.915673],
    [51.539099, -8.916616],
    [51.538565, -8.923051],
    [51.539687, -8.926397],
    [51.546488, -8.926673],
    [51.54318, -8.939967],
    [51.537201, -8.939452],
    [51.533357, -8.944085],
    [51.528018, -8.950625],
    [51.52994, -8.95972],
    [51.548518, -8.958175],
    [51.559405, -8.987346],
    [51.561219, -8.988782],
    [51.56378, -8.995646],
    [51.556737, -9.01761],
    [51.558551, -9.01984],
    [51.558871, -9.02842],
    [51.553855, -9.030136],
    [51.5514, -9.033739],
    [51.549692, -9.04678],
    [51.549159, -9.062223],
    [51.543074, -9.087619],
    [51.551614, -9.105979],
    [51.556097, -9.109754],
    [51.55631, -9.115759],
    [51.535968, -9.105669],
    [51.534639, -9.111985],
    [51.528979, -9.113872],
    [51.524066, -9.132061],
    [51.515462, -9.159194],
    [51.503982, -9.178628],
    [51.503555, -9.204882],
    [51.479202, -9.208378],
    [51.47407, -9.257796],
    [51.405588, -9.522732],
    [51.427, -9.540578],
    [51.505708, -9.459587],
    [51.475781, -9.585878],
    [51.480292, -9.631714],
    [51.500814, -9.644069],
    [51.490127, -9.695546],
    [51.467034, -9.6928],
    [51.440698, -9.764303],
    [51.437274, -9.820585],
    [51.457815, -9.845294],
    [51.492029, -9.835685],
    [51.563797, -9.651739],
    [51.573186, -9.659976],
    [51.537132, -9.815681],
    [51.535616, -9.853471],
    [51.548427, -9.852099],
    [51.699257, -9.507004],
    [51.703587, -9.510233],
    [51.639637, -9.779634],
    [51.614275, -9.83214],
    [51.606269, -9.891908],
    [51.613518, -9.896713],
    [51.584515, -10.041536],
    [51.587502, -10.058695],
    [51.59935, -10.055636],
    [51.592952, -10.104024],
    [51.596364, -10.115349],
    [51.578019, -10.162034],
    [51.579512, -10.168554],
    [51.59774, -10.156224],
    [51.570007, -10.237901],
    [51.587928, -10.246138],
    [51.625029, -10.137006],
    [51.625029, -10.077292],
    [51.64719, -10.072442],
    [51.658266, -10.117056],
    [51.677005, -10.097838],
    [51.673598, -10.08411],
    [51.688925, -9.994883],
    [51.708502, -9.991451],
    [51.702268, -10.061025],
    [51.792861, -9.809642],
    [51.800887, -9.816755],
    [51.72571, -10.146002],
    [51.74527, -10.161102],
    [51.768222, -10.248956],
    [51.79456, -10.207774],
    [51.814473, -10.20377],
    [51.788996, -10.291625],
    [51.761805, -10.363006],
    [51.826357, -10.365752],
    [51.828055, -10.439879],
    [51.924706, -10.437134],
    [52.088704, -9.959425],
    [52.105577, -9.986879],
    [52.085329, -10.346534],
    [52.088325, -10.478231],
    [52.185258, -10.486468],
    [52.29374, -10.177604],
    [52.289541, -10.152797],
    [52.250043, -10.122597],
    [52.288701, -10.04847],
    [52.305876, -10.071878],
    [52.320988, -10.000496],
    [52.263871, -10.003241],
    [52.243695, -9.934605],
    [52.379707, -9.865969],
    [52.388089, -9.96206],
    [52.433325, -9.953823],
    [52.440023, -9.857693],
    [52.496912, -9.709438],
    [52.548718, -9.703947],
    [52.540366, -9.956529],
    [52.562077, -9.956529],
    [52.758653, -9.613348],
    [52.752004, -9.536475],
    [52.911304, -9.41842],
    [52.927864, -9.511766],
    [53.1541, -9.29762],
    [53.145864, -9.138384],
    [53.242948, -9.023075],
    [53.206773, -9.687475],
    [53.213352, -9.786311],
    [53.272523, -9.775329],
    [53.290586, -9.934566],
    [53.362764, -9.920838],
    [53.362764, -10.041638],
    [53.393894, -10.063602],
    [53.385704, -10.184402],
    [53.403719, -10.231075],
    [53.45445, -10.170675],
    [53.55736, -10.23382],
    [53.580195, -10.071838],
    [53.616054, -10.069093],
    [53.614425, -9.956529],
    [53.759185, -9.926329],
    [53.801381, -9.69022],
    [53.867834, -9.679238],
    [53.848395, -9.912602],
    [53.850015, -9.975747],
    [53.90183, -10.027911],
    [53.903448, -10.060856],
    [53.921244, -10.080075],
    [53.953581, -10.26402],
    [53.993966, -10.26402],
    [54.05044, -9.96202],
    [54.087509, -10.162438],
    [54.254716, -10.129453],
    [54.315642, -10.033611],
    [54.293206, -9.899084],
    [54.347672, -9.866138],
    [54.32205, -9.273121],
    [54.288256, -9.209334],
    [54.244947, -9.188724],
    [54.226086, -9.190785],
    [54.214443, -9.109717],
    [54.298275, -9.057504],
    [54.293467, -8.931781],
    [54.255689, -8.827903],
    [54.282956, -8.758858],
    [54.27182, -8.749938],
    [54.271018, -8.648947],
    [54.311496, -8.57953],
    [54.338326, -8.59327],
    [54.318706, -8.6393],
    [54.316703, -8.657849],
    [54.324713, -8.668154],
    [54.346732, -8.687391],
    [54.362518, -8.679104],
    [54.436685, -8.487536],
    [54.46902, -8.488903],
    [54.475803, -8.446308],
    [54.457626, -8.430352],
    [54.495129, -8.276461],
    [54.527019, -8.276461],
    [54.546141, -8.240737],
    [54.569236, -8.222874],
    [54.593908, -8.183028],
    [54.630491, -8.178906],
    [54.590725, -8.297072],
    [54.59709, -8.314934],
    [54.631286, -8.290202],
    [54.570032, -8.430352],
    [54.555699, -8.460581],
    [54.56207, -8.470199],
    [54.582767, -8.459207],
    [54.597886, -8.508671],
    [54.614589, -8.702409],
    [54.636671, -8.698958],
    [54.648591, -8.78346],
    [54.657728, -8.799261],
    [54.698222, -8.811628],
    [54.706157, -8.806819],
    [54.714487, -8.758728],
    [54.724799, -8.768393],
    [54.768395, -8.696299],
    [54.780276, -8.574043],
    [54.803633, -8.517021],
    [54.819461, -8.571982],
    [54.835856, -8.56368],
    [54.853578, -8.4086],
    [54.882226, -8.395203],
    [54.908554, -8.470218],
    [54.965573, -8.469067],
    [54.968332, -8.572805],
    [54.975032, -8.574866],
    [55.012847, -8.571431],
    [55.024263, -8.543264],
    [55.013241, -8.439525],
    [55.055651, -8.469079],
    [55.064303, -8.452582],
    [55.095227, -8.390568],
    [55.095227, -8.390568],
    [55.161396, -8.296158],
    [55.166672, -8.116218],
    [55.180789, -8.047517],
    [55.227026, -8.028281],
    [55.227026, -7.940343],
    [55.192549, -7.936221],
    [55.256777, -7.802941],
    [55.255212, -7.735613],
    [55.283378, -7.646302],
    [55.268251, -7.512894],
    [55.273141, -7.527321],
    [55.279399, -7.529725],
    [55.287611, -7.523542],
    [55.290739, -7.5016],
    [55.283505, -7.479615],
    [55.295821, -7.471028],
    [55.296408, -7.461753],
    [55.288589, -7.445952],
    [55.295235, -7.392021],
    [55.321615, -7.377029],
    [55.315559, -7.33787],
    [55.322396, -7.336496],
    [55.329818, -7.357106],
    [55.353442, -7.354014],
    [55.360273, -7.390083],
    [55.371873, -7.404914],
    [55.387087, -7.387052],
    [55.344551, -7.169956],
    [55.306405, -7.14675],
    [55.258558, -6.957776],
    [55.236247, -6.916555],
    [55.191765, -6.936447],
    [55.173731, -6.889731],
    [55.176084, -6.737214],
    [55.200387, -6.726222],
    [55.223893, -6.550347],
    [55.237207, -6.544851],
    [55.255212, -6.483228],
    [55.237207, -6.407656],
    [55.252864, -6.366436],
    [55.209615, -6.236069],
    [55.213533, -6.187979],
    [55.227633, -6.159811],
    [55.231725, -6.142587],
    [55.161396, -6.007402],
    [55.061245, -6.049997],
    [55.062032, -5.99641],
    [55.05102, -5.957937],
    [54.987159, -5.987891],
    [54.980318, -5.981193],
    [54.981795, -5.971232],
    [54.980416, -5.962644],
    [54.971486, -5.955238],
    [54.969121, -5.922261],
    [54.900446, -5.859821],
    [54.901532, -5.844189],
    [54.869584, -5.810333],
    [54.853074, -5.719581],
    [54.80957, -5.683856],
    [54.765622, -5.679047],
    [54.71885, -5.73813],
    [54.699015, -5.839808],
    [54.653756, -5.905074],
    [54.64144, -5.856297],
    [54.654153, -5.833625],
    [54.681553, -5.73813],
    [54.67123, -5.719581],
    [54.672024, -5.643323],
    [54.682128, -5.64251],
    [54.683845, -5.539393],
    [54.680669, -5.523248],
    [54.672332, -5.517065],
    [54.645949, -5.511459],
    [54.478736, -5.412484],
    [54.373279, -5.450957],
    [54.238126, -5.599363],
    [54.240935, -5.626156],
    [54.226888, -5.641958],
    [54.222071, -5.666003],
    [54.245349, -5.690048],
    [54.213239, -5.87477],
    [54.175076, -5.863091],
    [54.122393, -5.879579],
    [54.099047, -5.893319],
    [54.075194, -5.946642],
    [54.06371, -5.949733],
    [54.058673, -5.961691],
    [54.051417, -5.998103],
    [54.03408, -6.016309],
    [54.018037, -6.067071],
    [54.070047, -6.192795],
    [54.088577, -6.203787],
    [54.088979, -6.249819],
    [54.035676, -6.130358],
    [54.000797, -6.093173],
    [53.972536, -6.146417],
    [53.974848, -6.226362],
    [54.005126, -6.329414],
    [54.009564, -6.388532],
    [53.971799, -6.543666],
    [53.835066, -6.740152],
    [53.613529, -6.876855],
    [53.131777, -7.063722],
    [52.827495, -7.041738],
    [52.666056, -6.953325],
    [52.519229, -6.755466],
    [52.447473, -6.278024],
  ],
  [
    [50.591694, -4.905874],
    [50.514911, -4.762264],
    [50.439752, -4.699059],
    [50.309888, -4.667723],
    [50.311867, -4.672936],
    [50.313596, -4.676558],
    [50.316775, -4.677245],
    [50.31809, -4.685832],
    [50.320489, -4.685362],
    [50.336964, -4.684955],
    [50.34131, -4.690938],
    [50.345993, -4.690638],
    [50.346767, -4.701696],
    [50.344131, -4.699611],
    [50.339843, -4.705747],
    [50.333239, -4.740624],
    [50.331595, -4.744233],
    [50.328886, -4.755724],
    [50.320357, -4.762985],
    [50.309833, -4.76058],
    [50.305667, -4.751992],
    [50.297334, -4.750962],
    [50.289438, -4.771229],
    [50.262669, -4.780503],
    [50.256524, -4.763328],
    [50.247743, -4.767794],
    [50.241156, -4.785543],
    [50.235666, -4.777986],
    [50.229517, -4.793444],
    [50.218095, -4.794818],
    [50.216777, -4.806497],
    [50.22782, -4.818185],
    [50.228199, -4.869639],
    [50.193924, -4.918417],
    [50.194619, -4.923844],
    [50.200608, -4.924531],
    [50.201616, -4.951757],
    [50.18711, -4.964744],
    [50.163363, -4.971614],
    [50.154601, -4.982798],
    [50.152401, -4.97971],
    [50.150531, -4.980996],
    [50.149046, -4.985544],
    [50.146846, -4.996622],
    [50.13832, -5.008645],
    [50.140068, -5.014056],
    [50.140288, -5.017534],
    [50.144744, -5.015473],
    [50.154296, -5.032071],
    [50.176997, -5.02622],
    [50.201177, -5.042673],
    [50.181614, -5.052978],
    [50.175458, -5.041299],
    [50.155665, -5.05126],
    [50.151705, -5.043016],
    [50.142245, -5.040268],
    [50.137184, -5.074619],
    [50.131902, -5.07084],
    [50.123979, -5.086985],
    [50.114733, -5.085954],
    [50.10989, -5.078741],
    [50.093153, -5.096947],
    [50.08378, -5.068098],
    [50.07012, -5.07222],
    [50.062627, -5.057106],
    [50.050283, -5.052984],
    [50.030879, -5.063289],
    [50.021175, -5.08596],
    [50.0022, -5.088021],
    [49.997345, -5.108632],
    [49.994256, -5.158783],
    [49.953628, -5.182829],
    [49.953628, -5.252217],
    [50.00529, -5.279011],
    [50.014998, -5.263896],
    [50.08378, -5.349773],
    [50.085102, -5.376296],
    [50.097437, -5.410647],
    [50.093913, -5.431944],
    [50.119455, -5.517134],
    [50.102282, -5.539805],
    [50.086864, -5.52263],
    [50.054251, -5.548016],
    [50.026468, -5.692975],
    [50.066153, -5.726639],
    [50.087746, -5.699845],
    [50.127721, -5.715563],
    [50.166662, -5.676403],
    [50.17194, -5.633895],
    [50.194583, -5.604696],
    [50.219292, -5.54184],
    [50.219292, -5.473138],
    [50.200517, -5.464959],
    [50.192825, -5.435761],
    [50.218974, -5.40038],
    [50.240497, -5.40038],
    [50.24423, -5.374989],
    [50.237813, -5.37245],
    [50.240887, -5.353901],
    [50.239899, -5.343596],
    [50.262889, -5.303935],
    [50.265523, -5.290174],
    [50.269423, -5.286954],
    [50.275348, -5.277164],
    [50.277981, -5.26411],
    [50.281601, -5.261362],
    [50.284234, -5.24934],
    [50.305667, -5.238018],
    [50.31954, -5.237204],
    [50.323486, -5.220372],
    [50.322828, -5.203884],
    [50.335649, -5.185678],
    [50.341018, -5.182415],
    [50.342552, -5.170564],
    [50.3454, -5.167987],
    [50.349672, -5.157203],
    [50.372938, -5.15151],
    [50.379487, -5.157382],
    [50.381403, -5.153002],
    [50.388736, -5.160216],
    [50.39005, -5.15721],
    [50.390652, -5.147506],
    [50.395084, -5.143985],
    [50.401485, -5.150941],
    [50.40605, -5.146899],
    [50.413599, -5.12251],
    [50.413818, -5.104133],
    [50.41882, -5.098745],
    [50.420918, -5.100697],
    [50.426003, -5.102114],
    [50.426195, -5.097348],
    [50.421219, -5.093531],
    [50.421273, -5.087219],
    [50.415871, -5.084687],
    [50.416364, -5.078246],
    [50.418059, -5.073866],
    [50.423801, -5.066993],
    [50.427738, -5.065962],
    [50.428066, -5.057375],
    [50.452744, -5.042848],
    [50.463127, -5.045768],
    [50.490039, -5.039212],
    [50.496881, -5.04991],
    [50.504087, -5.041322],
    [50.511074, -5.032391],
    [50.539776, -5.02793],
    [50.544903, -5.042529],
    [50.551666, -5.036175],
    [50.551011, -5.016766],
    [50.547085, -5.017282],
    [50.547521, -5.000965],
    [50.542503, -4.999591],
    [50.545121, -4.986881],
    [50.560063, -4.971252],
    [50.582196, -4.93381],
    [50.588656, -4.937746],
    [50.591762, -4.924349],
    [50.594922, -4.926324],
    [50.597833, -4.914383],
  ],
  [
    [39.43386, -0.266587],
    [40.473905, -2.614702],
    [41.750414, -2.460198],
    [41.391028, -3.730266],
    [40.72145, -5.226607],
    [40.484142, -5.429228],
    [39.833007, -7.498646],
    [39.877916, -8.988506],
    [39.382557, -9.326004],
    [39.372765, -9.404338],
    [39.357901, -9.413956],
    [39.343976, -9.368216],
    [39.325859, -9.361019],
    [39.324435, -9.363432],
    [39.322841, -9.362401],
    [39.30107, -9.348552],
    [39.243661, -9.343743],
    [39.235684, -9.346491],
    [39.219195, -9.345129],
    [39.073771, -9.424687],
    [39.061556, -9.418565],
    [38.995413, -9.429558],
    [38.941493, -9.420626],
    [38.778952, -9.504471],
    [38.771993, -9.495539],
    [38.768064, -9.496285],
    [38.765923, -9.495769],
    [38.74745, -9.474987],
    [38.705459, -9.489041],
    [38.69233, -9.458812],
    [38.69233, -9.439232],
    [38.687774, -9.427897],
    [38.688957, -9.417406],
    [38.693512, -9.412168],
    [38.695857, -9.41878],
    [38.702622, -9.404868],
    [38.700077, -9.391557],
    [38.679406, -9.348569],
    [38.672035, -9.323149],
    [38.676458, -9.315077],
    [38.683195, -9.312737],
    [38.692373, -9.290838],
    [38.696661, -9.275896],
    [38.69233, -9.234308],
    [38.694567, -9.118465],
    [38.841259, -9.037397],
    [38.744926, -9.023657],
    [38.7085, -9.056634],
    [38.653826, -9.103351],
    [38.685992, -9.141823],
    [38.68965, -9.149869],
    [38.663772, -9.267675],
    [38.501376, -9.194169],
    [38.40889, -9.232641],
    [38.40351, -9.190047],
    [38.425743, -9.155348],
    [38.428553, -9.05671],
    [38.51403, -8.89114],
    [38.478803, -8.909435],
    [38.364756, -8.802261],
    [38.139363, -8.807757],
    [37.937104, -8.899817],
    [37.911105, -8.813253],
    [37.732114, -8.821497],
    [37.585344, -8.822871],
    [37.309506, -8.88745],
    [37.021085, -9.007845],
    [36.977818, -8.945119],
    [37.052382, -8.837945],
    [37.073204, -8.66894],
    [37.103507, -8.655702],
    [37.076491, -8.42771],
    [37.079777, -8.363262],
    [37.06115, -8.284943],
    [37.075395, -8.158533],
    [36.964651, -7.927697],
    [36.966846, -7.878232],
    [37.149152, -7.413666],
    [37.140395, -6.951994],
    [36.806866, -6.446353],
    [36.586643, -6.402384],
    [36.157614, -6.05613],
    [35.963447, -5.609657],
    [36.101156, -5.326608],
    [36.389119, -5.186458],
    [36.490759, -4.889668],
    [36.464257, -4.691809],
    [36.676019, -4.364791],
    [36.657183, -2.663892],
    [36.798784, -2.515843],
    [36.80758, -2.327601],
    [36.705256, -2.201191],
    [36.725071, -2.102261],
    [36.937709, -1.883532],
    [37.359024, -1.585721],
    [37.516044, -1.157025],
    [37.572665, -0.640392],
    [37.704358, -0.836605],
    [37.792911, -0.778105],
    [37.771203, -0.749251],
    [37.956597, -0.688794],
    [37.985827, -0.643937],
    [38.174998, -0.59035],
    [38.184714, -0.503787],
    [38.317363, -0.503889],
    [38.343218, -0.399463],
    [38.411042, -0.378853],
    [38.740053, 0.259013],
    [38.859921, 0.118483],
    [38.928327, -0.090369],
    [39.16297, -0.200291],
    [39.356494, -0.266141],
  ],
  [
    [45.858264, 22.161565],
    [47.113878, 22.546291],
    [47.22591, 22.106604],
    [47.293016, 21.754853],
    [47.293016, 21.293181],
    [47.426972, 20.754564],
    [47.738215, 19.406905],
    [47.848925, 18.857296],
    [48.471829, 16.82374],
    [48.610032, 16.406037],
    [48.703288, 16.068991],
    [48.324848, 15.057709],
    [48.456166, 13.716662],
    [48.703288, 12.573474],
    [48.862547, 11.078535],
    [49.864192, 10.594879],
    [50.202924, 10.221144],
    [50.301271, 9.209863],
    [50.351419, 7.911529],
    [50.694196, 7.253862],
    [51.00978, 6.880128],
    [51.040876, 6.577842],
    [50.99941, 6.412959],
    [50.79795, 6.145551],
    [50.533333, 5.914715],
    [50.484425, 5.529988],
    [50.561258, 5.112285],
    [50.860404, 4.705574],
    [51.389652, 4.203933],
    [51.372509, 4.107751],
    [51.407516, 3.988456],
    [51.348499, 3.860471],
    [51.408972, 3.505999],
    [51.345797, 3.156336],
    [51.061854, 2.398715],
    [51.035954, 2.12391],
    [50.959659, 1.760033],
    [50.879579, 1.628127],
    [50.87308, 1.571824],
    [50.759666, 1.601643],
    [50.738161, 1.58378],
    [50.690238, 1.553283],
    [50.512379, 1.560317],
    [50.323371, 1.912067],
    [49.992556, 3.000294],
    [49.502739, 3.549904],
    [49.159077, 4.13249],
    [48.813013, 4.386929],
    [48.377051, 4.298992],
    [48.054952, 3.63946],
    [47.9226, 2.727108],
    [48.018222, 1.715826],
    [48.223575, 0.594622],
    [48.479112, -0.251776],
    [48.715793, -0.774299],
    [48.921958, -0.999639],
    [49.397122, -1.062643],
    [49.357781, -1.1341],
    [49.384608, -1.136849],
    [49.538132, -1.288009],
    [49.593355, -1.208307],
    [49.70339, -1.270245],
    [49.696617, -1.476984],
    [49.65885, -1.519584],
    [49.659294, -1.580048],
    [49.658405, -1.670744],
    [49.674405, -1.680364],
    [49.680625, -1.73327],
    [49.692175, -1.819157],
    [49.714824, -1.830837],
    [49.721039, -1.857634],
    [49.70994, -1.883744],
    [49.738515, -1.942302],
    [49.704056, -1.952262],
    [49.520974, -2.519015],
    [49.42616, -2.704815],
    [49.114332, -2.311343],
    [49.103545, -1.69021],
    [48.651964, -1.558288],
    [48.633362, -1.831298],
    [48.718602, -1.84504],
    [48.66421, -2.020936],
    [48.60976, -2.205077],
    [48.638808, -2.295774],
    [48.676907, -2.271038],
    [48.689601, -2.383722],
    [48.531612, -2.683295],
    [48.724038, -2.914158],
    [48.762639, -2.947123],
    [48.780288, -2.946435],
    [48.767165, -2.960864],
    [48.768975, -2.995906],
    [48.808785, -3.006213],
    [48.853082, -2.967048],
    [48.867989, -2.995219],
    [48.826418, -3.052935],
    [48.830487, -3.065303],
    [48.833651, -3.086603],
    [48.896437, -3.058432],
    [48.870699, -3.09897],
    [48.855341, -3.160122],
    [48.872506, -3.16768],
    [48.878828, -3.199286],
    [48.865731, -3.210279],
    [48.873409, -3.245321],
    [48.823169, -3.368225],
    [48.820259, -3.367762],
    [48.81619, -3.39078],
    [48.804433, -3.39181],
    [48.801041, -3.436815],
    [48.816388, -3.425152],
    [48.822491, -3.427214],
    [48.81684, -3.457446],
    [48.836885, -3.475128],
    [48.838919, -3.485348],
    [48.829787, -3.492423],
    [48.831369, -3.496374],
    [48.830628, -3.498013],
    [48.829724, -3.502479],
    [48.82656, -3.506773],
    [48.830289, -3.506086],
    [48.836956, -3.497497],
    [48.837357, -3.474371],
    [48.84278, -3.503225],
    [48.799379, -3.61246],
    [48.769869, -3.60834],
    [48.754429, -3.5836],
    [48.757258, -3.565738],
    [48.744808, -3.55061],
    [48.732242, -3.552671],
    [48.729122, -3.542317],
    [48.726858, -3.584501],
    [48.688343, -3.587593],
    [48.68177, -3.572822],
    [48.672702, -3.582784],
    [48.669301, -3.609234],
    [48.683583, -3.612669],
    [48.685396, -3.626409],
    [48.678823, -3.641867],
    [48.682903, -3.649767],
    [48.693782, -3.640493],
    [48.698994, -3.655263],
    [48.691742, -3.678267],
    [48.691742, -3.700595],
    [48.704432, -3.71571],
    [48.710776, -3.754526],
    [48.704659, -3.788189],
    [48.711002, -3.79609],
    [48.722328, -3.822895],
    [48.718478, -3.832416],
    [48.688972, -3.858397],
    [48.663216, -3.84785],
    [48.663179, -3.851639],
    [48.673155, -3.852326],
    [48.672022, -3.866753],
    [48.623934, -3.85267],
    [48.632784, -3.857135],
    [48.642313, -3.887364],
    [48.660684, -3.901448],
    [48.664766, -3.887707],
    [48.674062, -3.890799],
    [48.671341, -3.906944],
    [48.699849, -3.925527],
    [48.697697, -3.927915],
    [48.659097, -3.930275],
    [48.657611, -3.945297],
    [48.731161, -3.963582],
    [48.755838, -4.016816],
    [48.748821, -4.042583],
    [48.700529, -4.058838],
    [48.687952, -4.06004],
    [48.686932, -4.070861],
    [48.694184, -4.083742],
    [48.697017, -4.130459],
    [48.694751, -4.135096],
    [48.686365, -4.19229],
    [48.658866, -4.22505],
    [48.656891, -4.223637],
    [48.650768, -4.238752],
    [48.650541, -4.276709],
    [48.64419, -4.280144],
    [48.642261, -4.303502],
    [48.634321, -4.303331],
    [48.640498, -4.308599],
    [48.661087, -4.291142],
    [48.673331, -4.315874],
    [48.667714, -4.323739],
    [48.674742, -4.324769],
    [48.679049, -4.333357],
    [48.659879, -4.407284],
    [48.658972, -4.436826],
    [48.636743, -4.457436],
    [48.624944, -4.498657],
    [48.639919, -4.53713],
    [48.61632, -4.598274],
    [48.581809, -4.620945],
    [48.575903, -4.701325],
    [48.544546, -4.76247],
    [48.497702, -4.786515],
    [48.470395, -4.767344],
    [48.413912, -4.805817],
    [48.370141, -4.771466],
    [48.366948, -4.794824],
    [48.355998, -4.784519],
    [48.324049, -4.777214],
    [48.33044, -4.69546],
    [48.346415, -4.692712],
    [48.332392, -4.617415],
    [48.355439, -4.549744],
    [48.353386, -4.53566],
    [48.373003, -4.506119],
    [48.378248, -4.432952],
    [48.390105, -4.429173],
    [48.385317, -4.400319],
    [48.360458, -4.439478],
    [48.328283, -4.458371],
    [48.32075, -4.464216],
    [48.320978, -4.453927],
    [48.334446, -4.409958],
    [48.323718, -4.42371],
    [48.323718, -4.371841],
    [48.339239, -4.36291],
    [48.335587, -4.319284],
    [48.316184, -4.342986],
    [48.308523, -4.338831],
    [48.306696, -4.274939],
    [48.289338, -4.253641],
    [48.298932, -4.305167],
    [48.283604, -4.362764],
    [48.277207, -4.406733],
    [48.290914, -4.409481],
    [48.309106, -4.490298],
    [48.295827, -4.527131],
    [48.291899, -4.527895],
    [48.2907, -4.523344],
    [48.285161, -4.536483],
    [48.292128, -4.536397],
    [48.293042, -4.538372],
    [48.290586, -4.542322],
    [48.296696, -4.553916],
    [48.303947, -4.554517],
    [48.304918, -4.549708],
    [48.314737, -4.544383],
    [48.318105, -4.542924],
    [48.323755, -4.543696],
    [48.339504, -4.531416],
    [48.341558, -4.530543],
    [48.342413, -4.532947],
    [48.338464, -4.555577],
    [48.333415, -4.562618],
    [48.331959, -4.562962],
    [48.329991, -4.571976],
    [48.326909, -4.571504],
    [48.325376, -4.579086],
    [48.320318, -4.580263],
    [48.319347, -4.584514],
    [48.317046, -4.582825],
    [48.286557, -4.568372],
    [48.283587, -4.574899],
    [48.276161, -4.586578],
    [48.288613, -4.599459],
    [48.287356, -4.611654],
    [48.281759, -4.614402],
    [48.282787, -4.631062],
    [48.278726, -4.635157],
    [48.273471, -4.619012],
    [48.249878, -4.633472],
    [48.245534, -4.634331],
    [48.245357, -4.622812],
    [48.260444, -4.614568],
    [48.250844, -4.602889],
    [48.246957, -4.58434],
    [48.254958, -4.559951],
    [48.240784, -4.547928],
    [48.233695, -4.578157],
    [48.225793, -4.566903],
    [48.168123, -4.565529],
    [48.164918, -4.538736],
    [48.228538, -4.489271],
    [48.213899, -4.386219],
    [48.204747, -4.375227],
    [48.196051, -4.316831],
    [48.156673, -4.300347],
    [48.15255, -4.28096],
    [48.092505, -4.305006],
    [48.112222, -4.367524],
    [48.091129, -4.535155],
    [48.082873, -4.548895],
    [48.069694, -4.649937],
    [48.068311, -4.657397],
    [48.069267, -4.658726],
    [48.069399, -4.660169],
    [48.068933, -4.660712],
    [48.069134, -4.662166],
    [48.068895, -4.662726],
    [48.071419, -4.662726],
    [48.072465, -4.664894],
    [48.071304, -4.665796],
    [48.071519, -4.667148],
    [48.070186, -4.668026],
    [48.070056, -4.667447],
    [48.068952, -4.668026],
    [48.068436, -4.669422],
    [48.066864, -4.668223],
    [48.065743, -4.689067],
    [48.065743, -4.689067],
    [48.065743, -4.689067],
    [48.065743, -4.689067],
    [48.061613, -4.693189],
    [48.065628, -4.717578],
    [48.042564, -4.714143],
    [48.042335, -4.740286],
    [48.032596, -4.75452],
    [47.991254, -4.559409],
    [48.001363, -4.536051],
    [47.838844, -4.35159],
    [47.823863, -4.392467],
    [47.784973, -4.390425],
    [47.781282, -4.188443],
    [47.825557, -4.148596],
    [47.706481, -3.493116],
    [47.639901, -3.538459],
    [47.613986, -3.476628],
    [47.595468, -3.186709],
    [47.455441, -3.146862],
    [47.457298, -3.061673],
    [47.554704, -3.093275],
    [47.471642, -2.813446],
    [47.503623, -2.495221],
    [47.794338, -2.140762],
    [47.833255, -1.130419],
    [47.87546, -0.832961],
    [47.550209, -0.063507],
    [47.006105, 0.508087],
    [46.98, 0.3],
    [46.92, 0.2],
    [46.886102, -0.690215],
    [46.114753, 0.244122],
    [45.58675, 0.870677],
    [45.432768, 1.794021],
    [45.432768, 2.706373],
    [45.579061, 3.684678],
    [46.190859, 4.454132],
    [47.318159, 4.885924],
    [47.718817, 5.452022],
    [47.844317, 5.770796],
    [47.807436, 6.259948],
    [47.426043, 6.628187],
    [46.743249, 8.308016],
    [46.312411, 9.473188],
    [46.274455, 10.187681],
    [46.335172, 10.5834],
    [46.916128, 10.748283],
    [47.35706, 11.023088],
    [47.312386, 11.638651],
    [47.537627, 15.52704],
    [47.142843, 16.118808],
    [45.816667, 18],
    [45.084769, 19.932108],
    [44.976068, 20.360804],
    [45.162287, 20.646601],
    [45.270634, 21.053312],
    [45.394207, 21.503992],
  ],
  [
    [52.826707, 5.649923],
    [52.810938, 5.52795],
    [52.859886, 5.347953],
    [52.886887, 5.341594],
    [52.910082, 5.402051],
    [53.061726, 5.350739],
    [53.219067, 5.416733],
    [53.33075, 5.633558],
    [53.411865, 6.044391],
    [53.423323, 6.245887],
    [53.40859, 6.302222],
    [53.439687, 6.549547],
    [53.469126, 6.724048],
    [53.458497, 6.795497],
    [53.464312, 6.81094],
    [53.438961, 6.886855],
    [53.347026, 6.936074],
    [53.289601, 7.095461],
    [53.227166, 7.087217],
    [53.100126, 6.82397],
    [52.964687, 6.241384],
    [52.871948, 5.939099],
    [52.83546, 5.603837],
  ],
  [
    [55.343858, 8.663063],
    [55.351471, 8.720398],
    [55.34295, 8.884506],
    [55.325766, 8.866653],
    [55.308183, 8.874207],
    [55.298802, 8.819962],
    [55.292156, 8.744431],
    [55.300757, 8.65654],
    [55.3285, 8.669586],
  ],
  [
    [54.363228, 10.144501],
    [54.362628, 10.110168],
    [54.299167, 10.084763],
    [54.288747, 10.108795],
    [54.290551, 10.148621],
    [54.319797, 10.188446],
    [54.361228, 10.185013],
  ],
  [
    [53.899554, 10.696564],
    [53.890653, 10.660172],
    [53.864949, 10.629272],
    [53.845104, 10.651245],
    [53.836596, 10.684547],
    [53.844091, 10.720596],
    [53.879321, 10.730896],
    [53.898642, 10.700769],
  ],
  [
    [54.550881, 16.512451],
    [54.211773, 16.847534],
    [53.966912, 17.352905],
    [53.756344, 17.929688],
    [53.675073, 18.858032],
    [53.717353, 19.671021],
    [53.873097, 20.352173],
    [54.102409, 21.137695],
    [54.39767, 21.313477],
    [54.770118, 21.373901],
    [54.939509, 21.234512],
    [54.918993, 21.18988],
    [54.915047, 21.144562],
    [54.907547, 21.10817],
    [54.904784, 21.093063],
    [54.894913, 21.088943],
    [54.90281, 21.059418],
    [54.894123, 21.034698],
    [54.902415, 21.016159],
    [54.893729, 20.996933],
    [54.909264, 20.891876],
    [54.90281, 20.87883],
    [54.905573, 20.856857],
    [54.933592, 20.830078],
    [54.94858, 20.791626],
    [54.947397, 20.76004],
    [54.939115, 20.747681],
    [54.954239, 20.53894],
    [55.093066, 20.788879],
    [55.2421, 20.967407],
    [55.421766, 21.132202],
    [55.63164, 21.140442],
    [55.71837, 21.107483],
    [55.722605, 21.084824],
    [55.539579, 21.093063],
    [55.368459, 21.016846],
    [55.073178, 20.698242],
    [54.95897, 20.45929],
    [54.940042, 20.374146],
    [54.945564, 20.302734],
    [54.965465, 20.268059],
    [54.9562, 20.22171],
    [54.958172, 20.206947],
    [54.945751, 20.123863],
    [54.949497, 20.092621],
    [54.949694, 20.01915],
    [54.961685, 19.992199],
    [54.961291, 19.976406],
    [54.93162, 19.948425],
    [54.926885, 19.944305],
    [54.906363, 19.926453],
    [54.856592, 19.929199],
    [54.79924, 19.954605],
    [54.769939, 19.956665],
    [54.693023, 19.916153],
    [54.523234, 19.714966],
    [54.422685, 19.528198],
    [54.358717, 19.212341],
    [54.350714, 18.987122],
    [54.370439, 18.955536],
    [54.363238, 18.92807],
    [54.378438, 18.741302],
    [54.470317, 18.582001],
    [54.720417, 18.514709],
    [54.582151, 18.81546],
    [54.622322, 18.841553],
    [54.84238, 18.319702],
    [54.83289, 17.811584],
    [54.68447, 17.034302],
    [54.604449, 16.902466],
    [54.580579, 16.773376],
    [54.558009, 16.575623],
  ],
];

const coordinates_1350 = [
  [
    [55.310782, 14.780008],
    [55.257599, 14.845969],
    [55.226282, 14.942162],
    [55.216882, 14.98064],
    [55.190237, 15.010872],
    [55.133752, 15.164781],
    [55.07876, 15.173026],
    [54.979584, 15.109813],
    [54.974855, 15.043852],
    [55.080333, 14.648086],
    [55.108426, 14.689049],
    [55.125606, 14.697808],
    [55.207969, 14.692312],
    [55.27139, 14.744531],
    [55.294463, 14.74934],
  ],
  [
    [58.015227, 19.164496],
    [57.994854, 19.378641],
    [57.930747, 19.395114],
    [57.889891, 19.197441],
    [57.723073, 19.032714],
    [57.649663, 18.873478],
    [57.478779, 18.835041],
    [57.398956, 18.939369],
    [57.357498, 18.900932],
    [57.304125, 18.774641],
    [57.284164, 18.701074],
    [57.266347, 18.742256],
    [57.209867, 18.70931],
    [57.190525, 18.585765],
    [57.142871, 18.467711],
    [57.131358, 18.418422],
    [57.125395, 18.478822],
    [57.101534, 18.459603],
    [57.081389, 18.379985],
    [57.017898, 18.358022],
    [57.001447, 18.410185],
    [56.985738, 18.401949],
    [56.97601, 18.363513],
    [56.961038, 18.333313],
    [56.943064, 18.342922],
    [56.925081, 18.312722],
    [56.916837, 18.252322],
    [56.898841, 18.197413],
    [56.90634, 18.172722],
    [56.904841, 18.115058],
    [56.917586, 18.120525],
    [56.926515, 18.127092],
    [56.988188, 18.18645],
    [57.011001, 18.183705],
    [57.031558, 18.211846],
    [57.036789, 18.264696],
    [57.086818, 18.288718],
    [57.077489, 18.258495],
    [57.065918, 18.248886],
    [57.057704, 18.224864],
    [57.055464, 18.207704],
    [57.066394, 18.190579],
    [57.067141, 18.171361],
    [57.073258, 18.17292],
    [57.071858, 18.191967],
    [57.130072, 18.204255],
    [57.139388, 18.181605],
    [57.141996, 18.158955],
    [57.166948, 18.138363],
    [57.239102, 18.136304],
    [57.249505, 18.07865],
    [57.288859, 18.098554],
    [57.317707, 18.159674],
    [57.383155, 18.168515],
    [57.428282, 18.08066],
    [57.534589, 18.101251],
    [57.601609, 18.176751],
    [57.615587, 18.238524],
    [57.818759, 18.438942],
    [57.851657, 18.594156],
    [57.899854, 18.640829],
    [57.942885, 18.743783],
    [57.859695, 18.795947],
    [57.93195, 18.82752],
    [57.921741, 19.019701],
    [57.993143, 19.102065],
    [58.005515, 19.200901],
  ],
  [
    [55.683479, 13.053786],
    [55.643974, 13.041774],
    [55.645611, 13.025629],
    [55.635923, 12.986506],
    [55.618866, 12.97072],
    [55.605292, 12.960424],
    [55.591714, 12.912379],
    [55.58046, 12.91032],
    [55.568426, 12.88767],
    [55.562083, 12.886626],
    [55.425468, 12.919916],
    [55.420792, 12.885598],
    [55.443213, 12.868392],
    [55.438928, 12.836132],
    [55.377121, 12.78808],
    [55.351969, 12.810051],
    [55.376272, 12.822756],
    [55.38973, 12.849524],
    [55.381734, 12.923994],
    [55.392655, 12.940138],
    [55.398894, 12.968965],
    [55.365239, 13.068079],
    [55.36823, 13.088972],
    [55.37379, 13.098066],
    [55.371741, 13.133071],
    [55.360664, 13.147497],
    [55.322035, 13.345268],
    [55.380846, 13.514423],
    [55.383577, 13.602277],
    [55.413601, 13.646205],
    [55.411652, 13.681209],
    [55.421396, 13.712782],
    [55.416115, 13.828531],
    [55.42235, 13.930113],
    [55.376945, 14.044353],
    [55.375385, 14.063845],
    [55.371483, 14.203863],
    [55.394605, 14.216271],
    [55.441655, 14.254655],
    [55.451001, 14.277305],
    [55.472131, 14.287699],
    [55.484194, 14.320644],
    [55.495864, 14.328194],
    [55.507877, 14.351382],
    [55.52386, 14.351873],
    [55.556301, 14.365966],
    [55.565427, 14.345027],
    [55.590075, 14.335418],
    [55.896568, 14.324623],
    [55.976565, 14.555241],
    [55.951968, 14.708987],
    [56.03185, 14.829787],
    [56.099313, 14.763896],
    [55.976565, 15.785204],
    [56.185005, 16.542949],
    [57.287653, 17.223822],
    [57.595097, 16.784549],
    [58.464401, 17.092496],
    [58.690928, 17.95045],
    [59.386101, 19.10354],
    [59.849781, 19.22257],
    [60.407885, 18.717407],
    [60.740102, 17.411759],
    [61.277889, 17.389795],
    [61.105567, 13.578731],
    [60.227812, 12.913817],
    [59.231052, 12.342763],
    [58.526978, 12.167054],
    [57.218419, 13.221308],
    [55.958119, 13.40221],
  ],
  [
    [56.10073, 12.488564],
    [56.040941, 12.638191],
    [55.925701, 12.533864],
    [55.763363, 12.617565],
    [55.735539, 12.598347],
    [55.724365, 12.641025],
    [55.672512, 12.65338],
    [55.670963, 12.734378],
    [55.671738, 12.792033],
    [55.607406, 12.826351],
    [55.598096, 12.818114],
    [55.582575, 12.691823],
    [55.566485, 12.64246],
    [55.549184, 12.592998],
    [55.555399, 12.551817],
    [55.591889, 12.491417],
    [55.594993, 12.406308],
    [55.543746, 12.264917],
    [55.441051, 12.216871],
    [55.413776, 12.273153],
    [55.393503, 12.40768],
    [55.334964, 12.459844],
    [55.276338, 12.463962],
    [55.231725, 12.363753],
    [55.22311, 12.238835],
    [55.172947, 12.129017],
    [55.133713, 12.129017],
    [55.11094, 12.192162],
    [54.972727, 12.617857],
    [54.919092, 12.551966],
    [54.93803, 12.365275],
    [54.67526, 11.997384],
    [54.544827, 12.008366],
    [54.550483, 11.917632],
    [54.632876, 11.858484],
    [54.626516, 11.527322],
    [54.597886, 11.457313],
    [54.639234, 11.340617],
    [54.694035, 11.25139],
    [54.75748, 10.965863],
    [54.83111, 10.948018],
    [54.819244, 11.012536],
    [54.859576, 11.012536],
    [54.899869, 10.997436],
    [54.953095, 11.104243],
    [54.965711, 11.247006],
    [55.013694, 11.732602],
    [55.168594, 11.532575],
    [55.135636, 11.161939],
    [55.137854, 11.131164],
    [55.33141, 11.074017],
    [55.373824, 11.105056],
    [55.385917, 11.199774],
    [55.418278, 11.181243],
    [55.5041, 11.134489],
    [55.507211, 11.07409],
    [55.536189, 11.078956],
    [55.540463, 11.134551],
    [55.621967, 11.098174],
    [55.658008, 10.921092],
    [55.674661, 10.932074],
    [55.662656, 11.05356],
    [55.682017, 11.050129],
    [55.694964, 11.006734],
    [55.720043, 10.985588],
    [55.725844, 10.888468],
    [55.743434, 10.86237],
    [55.744014, 10.869233],
    [55.746139, 10.897718],
    [55.750391, 10.920024],
    [55.749705, 10.991062],
    [55.73463, 11.047344],
    [55.738496, 11.078288],
    [55.753569, 11.11947],
    [55.755501, 11.184674],
    [55.736177, 11.192911],
    [55.737336, 11.212129],
    [55.747879, 11.216649],
    [55.748265, 11.226944],
    [55.731064, 11.254742],
    [55.735123, 11.277392],
    [55.756573, 11.283912],
    [55.796823, 11.272628],
    [55.793349, 11.299396],
    [55.755115, 11.324792],
    [55.77443, 11.36666],
    [55.836945, 11.363228],
    [55.836559, 11.348814],
    [55.845725, 11.355711],
    [55.846496, 11.36635],
    [55.833773, 11.391059],
    [55.849667, 11.444931],
    [55.850438, 11.486799],
    [55.926298, 11.510825],
    [55.970302, 11.275995],
    [56.016386, 11.267759],
    [55.994887, 11.308941],
    [55.951853, 11.525832],
    [55.963384, 11.594468],
    [55.945701, 11.623295],
    [55.956466, 11.704286],
    [55.977986, 11.779786],
    [56.007941, 11.930868],
    [56.125232, 12.217768],
    [56.135182, 12.301504],
    [56.111452, 12.375631],
    [56.095368, 12.425049],
  ],
  [
    [55.168849, 10.936096],
    [55.133713, 10.881766],
    [55.000384, 10.790979],
    [54.94091, 10.69231],
    [54.946559, 10.680055],
    [54.844555, 10.63741],
    [54.841392, 10.579756],
    [54.821617, 10.587992],
    [54.80579, 10.634665],
    [54.714666, 10.670355],
    [54.711493, 10.715655],
    [54.740261, 10.740428],
    [54.970086, 10.874825],
    [54.986637, 10.910666],
    [55.158042, 10.968321],
    [55.165103, 10.950475],
  ],
  [
    [54.961414, 10.180184],
    [54.806582, 10.398448],
    [54.81133, 10.442375],
    [54.832514, 10.4548],
    [54.841609, 10.5454],
    [54.883105, 10.485664],
    [54.898112, 10.453405],
    [54.886265, 10.421832],
    [54.913113, 10.406732],
    [54.91706, 10.384082],
    [54.893768, 10.383396],
    [54.900086, 10.339469],
    [54.939943, 10.296228],
    [54.945859, 10.260537],
    [54.973062, 10.221397],
    [54.974244, 10.193943],
  ],
  [
    [56.017499, 10.521105],
    [55.939125, 10.488159],
    [55.914505, 10.515614],
    [55.906808, 10.565032],
    [55.874463, 10.567778],
    [55.852885, 10.515614],
    [55.760273, 10.534812],
    [55.75838, 10.631442],
    [55.805487, 10.660269],
    [55.840203, 10.654779],
    [55.870476, 10.693042],
    [55.920142, 10.697161],
    [55.928712, 10.614826],
    [55.952746, 10.580164],
    [56.004035, 10.563669],
    [56.002072, 10.554242],
  ],
  [
    [55.914505, -2.114975],
    [55.581139, -2.758652],
    [55.537646, -3.263815],
    [55.288188, -3.296761],
    [55.200505, -3.538361],
    [55.169143, -3.922724],
    [55.030856, -4.186288],
    [54.917356, -4.109415],
    [54.803535, -3.790942],
    [54.745077, -3.965545],
    [54.762235, -4.141686],
    [54.830319, -4.287195],
    [54.873012, -4.401131],
    [54.863528, -4.409368],
    [54.829528, -4.398386],
    [54.810539, -4.340731],
    [54.706732, -4.339359],
    [54.68451, -4.35034],
    [54.667835, -4.381913],
    [54.708319, -4.552131],
    [54.761442, -4.607535],
    [54.838229, -4.85188],
    [54.808956, -4.943857],
    [54.695623, -4.883457],
    [54.685304, -4.860121],
    [54.627311, -4.846394],
    [54.63685, -4.950721],
    [54.692448, -4.99053],
    [54.959404, -5.232535],
    [55.012985, -5.163898],
    [55.53003, -4.724995],
    [55.685172, -5.026995],
    [55.411711, -5.054483],
    [55.430416, -5.477283],
    [55.305545, -5.510228],
    [55.249224, -5.795755],
    [55.318558, -5.824317],
    [55.396623, -5.814708],
    [55.938279, -5.768678],
    [55.564214, -6.114605],
    [55.580596, -6.204887],
    [55.560408, -6.254305],
    [55.588222, -6.350181],
    [55.696512, -6.304972],
    [55.712762, -6.385963],
    [55.65857, -6.49029],
    [55.685675, -6.558927],
    [55.853309, -6.476522],
    [56.238618, -6.246305],
    [56.259982, -6.531833],
    [56.44701, -7.108972],
    [56.815614, -7.745917],
    [57.671555, -7.701989],
    [58.288994, -7.076026],
    [58.63379, -6.318281],
    [58.670655, -4.881885],
    [58.679508, -3.013022],
    [58.38703, -2.980076],
    [57.929142, -3.847639],
    [57.835687, -3.715858],
    [57.683303, -3.869603],
    [57.753714, -3.408367],
    [57.712658, -1.859931],
    [57.44761, -1.651277],
    [56.374073, -2.661604],
    [56.288803, -2.496876],
    [56.117692, -2.782404],
  ],
  [
    [47.113878, 22.546291],
    [47.113878, 22.546291],
    [47.22591, 22.106604],
    [47.293016, 21.754853],
    [47.293016, 21.293181],
    [47.426972, 20.754564],
    [47.738215, 19.406905],
    [47.848925, 18.857296],
    [48.471829, 16.82374],
    [48.610032, 16.406037],
    [48.703288, 16.068991],
    [48.324848, 15.057709],
    [48.456166, 13.716662],
    [48.703288, 12.573474],
    [48.862547, 11.078535],
    [49.864192, 10.594879],
    [50.202924, 10.221144],
    [50.301271, 9.209863],
    [50.351419, 7.911529],
    [50.694196, 7.253862],
    [51.00978, 6.880128],
    [51.040876, 6.577842],
    [50.99941, 6.412959],
    [50.79795, 6.145551],
    [50.533333, 5.914715],
    [50.484425, 5.529988],
    [50.561258, 5.112285],
    [50.860404, 4.705574],
    [51.389652, 4.203933],
    [51.372509, 4.107751],
    [51.407516, 3.988456],
    [51.348499, 3.860471],
    [51.408972, 3.505999],
    [51.540954, 3.403113],
    [51.600704, 3.573513],
    [51.600704, 3.66145],
    [51.713161, 3.669695],
    [51.799868, 3.834577],
    [51.879755, 4.033646],
    [51.916193, 3.971815],
    [51.966142, 3.952579],
    [51.989828, 3.989677],
    [51.984753, 4.076206],
    [52.155147, 4.321157],
    [52.91503, 4.671107],
    [52.977465, 4.643465],
    [53.232098, 4.809598],
    [53.47121, 5.345869],
    [53.494092, 6.08732],
    [53.515695, 6.142981],
    [53.549161, 6.438397],
    [53.606237, 6.648622],
    [53.675439, 6.851978],
    [53.816382, 7.868056],
    [53.775379, 8.067798],
    [53.737218, 8.187338],
    [53.705974, 8.219073],
    [53.696219, 8.109151],
    [53.716906, 8.059554],
    [53.771, 7.86],
    [53.74, 7.751904],
    [53.670192, 7.207791],
    [53.454858, 6.350631],
    [53.445, 6.1],
    [53.284429, 5.174467],
    [52.981227, 4.844701],
    [52.91503, 4.833709],
    [52.963405, 5.049039],
    [52.928278, 5.086529],
    [52.762393, 5.185459],
    [52.7503, 5.31635],
    [52.672552, 5.399807],
    [52.569172, 5.103017],
    [52.351615, 5.092025],
    [52.606133, 5.572909],
    [52.761105, 5.581222],
    [52.826707, 5.649923],
    [52.83546, 5.603837],
    [52.871948, 5.939099],
    [52.964687, 6.241384],
    [53.100126, 6.82397],
    [53.227166, 7.087217],
    [53.289601, 7.095461],
    [53.259227, 7.097829],
    [53.244026, 7.198477],
    [53.247842, 7.210358],
    [53.318334, 7.237943],
    [53.333682, 7.014728],
    [53.369749, 6.985874],
    [53.505548, 7.026538],
    [53.545142, 7.024477],
    [53.515348, 7.101427],
    [53.532084, 7.129595],
    [53.571246, 7.08013],
    [53.580246, 7.088652],
    [53.616828, 7.133225],
    [53.662422, 7.212918],
    [53.689266, 7.317344],
    [53.686013, 7.489097],
    [53.676253, 7.512455],
    [53.703089, 7.691079],
    [53.703089, 7.729551],
    [53.716906, 7.930159],
    [53.70634, 8.035959],
    [53.6494, 8.051131],
    [53.641259, 8.096474],
    [53.524676, 8.192656],
    [53.464221, 8.096474],
    [53.416776, 8.258609],
    [53.505895, 8.290212],
    [53.514062, 8.224259],
    [53.608681, 8.229755],
    [53.604607, 8.360885],
    [53.572816, 8.393862],
    [53.541817, 8.549127],
    [53.684387, 8.463826],
    [53.868603, 8.573646],
    [53.896935, 8.686316],
    [53.883985, 8.691813],
    [53.852405, 8.749522],
    [53.838287, 8.798079],
    [53.829778, 8.912123],
    [53.829778, 8.912123],
    [53.873461, 9.164447],
    [53.887223, 8.945977],
    [54.021365, 8.822016],
    [54.045854, 8.8468],
    [54.020216, 8.964364],
    [54.038304, 8.994146],
    [54.12692, 8.932315],
    [54.106797, 8.853996],
    [54.175236, 8.796799],
    [54.226648, 8.835271],
    [54.237715, 8.827202],
    [54.285611, 8.821406],
    [54.273585, 8.780873],
    [54.287214, 8.714232],
    [54.262758, 8.684691],
    [54.259549, 8.659271],
    [54.291222, 8.580265],
    [54.309654, 8.574769],
    [54.359297, 8.59744],
    [54.392093, 8.604998],
    [54.422685, 8.44574],
    [54.660091, 8.250732],
    [54.8819, 8.247986],
    [55.137049, 8.407288],
    [55.29374, 8.467712],
    [55.308183, 8.526764],
    [55.305838, 8.604355],
    [55.300757, 8.65654],
    [55.292156, 8.744431],
    [55.298802, 8.819962],
    [55.308183, 8.874207],
    [55.325766, 8.866653],
    [55.34295, 8.884506],
    [55.351471, 8.720398],
    [55.343858, 8.663063],
    [55.33514, 8.475266],
    [55.336702, 8.421707],
    [55.449794, 8.306351],
    [55.527212, 8.175201],
    [55.557903, 8.059845],
    [55.730745, 8.146362],
    [56.055706, 8.083191],
    [56.534273, 8.096924],
    [56.706541, 8.184814],
    [56.841011, 8.223267],
    [57.143244, 8.580322],
    [57.116412, 8.761597],
    [57.158142, 8.97583],
    [57.149204, 9.223022],
    [57.190897, 9.415283],
    [57.605251, 9.904175],
    [57.592963, 10.148621],
    [57.758916, 10.566101],
    [57.742795, 10.670471],
    [57.573822, 10.450745],
    [57.460243, 10.566101],
    [57.332971, 10.535889],
    [57.325557, 11.217041],
    [57.272138, 11.208801],
    [57.193353, 11.027527],
    [57.208231, 10.560608],
    [57.092544, 10.426025],
    [56.741729, 10.327148],
    [56.648224, 10.393066],
    [56.544874, 10.39032],
    [56.519125, 10.497437],
    [56.544874, 10.821533],
    [56.441772, 10.978088],
    [56.339912, 10.925903],
    [56.135373, 10.741882],
    [56.027092, 10.310669],
    [55.820882, 10.217285],
    [55.676578, 10.033264],
    [55.567009, 9.816284],
    [55.519846, 9.882202],
    [55.63164, 10.280457],
    [55.533838, 10.552368],
    [55.622064, 10.588074],
    [55.614309, 10.645752],
    [55.461261, 10.766602],
    [55.448256, 10.678711],
    [55.323441, 10.829773],
    [55.292176, 10.859985],
    [55.05218, 10.758362],
    [54.976589, 10.71167],
    [54.929272, 10.623779],
    [55.000778, 10.151367],
    [55.202934, 9.813538],
    [55.09778, 9.74762],
    [54.998651, 10.022278],
    [54.867401, 10.085449],
    [54.843685, 9.994812],
    [54.844476, 9.776459],
    [54.783543, 9.820404],
    [54.800962, 9.900055],
    [54.758986, 9.994812],
    [54.714586, 10.005798],
    [54.679667, 10.05661],
    [54.502506, 10.025024],
    [54.490523, 10.150681],
    [54.451419, 10.211792],
    [54.427858, 10.18158],
    [54.403485, 10.200806],
    [54.384696, 10.196686],
    [54.363228, 10.144501],
    [54.362628, 10.110168],
    [54.299167, 10.084763],
    [54.288747, 10.108795],
    [54.290551, 10.148621],
    [54.319797, 10.188446],
    [54.361228, 10.185013],
    [54.361566, 10.177588],
    [54.363317, 10.183339],
    [54.365776, 10.194969],
    [54.379812, 10.192459],
    [54.380437, 10.199325],
    [54.386464, 10.206857],
    [54.395918, 10.208874],
    [54.407177, 10.218143],
    [54.415169, 10.226898],
    [54.420096, 10.275221],
    [54.421581, 10.275607],
    [54.433378, 10.302086],
    [54.435941, 10.326462],
    [54.425991, 10.39238],
    [54.402426, 10.457611],
    [54.357637, 10.626526],
    [54.336825, 10.652618],
    [54.325614, 10.678711],
    [54.310986, 10.687637],
    [54.306178, 10.70755],
    [54.310785, 10.737762],
    [54.306779, 10.755272],
    [54.312988, 10.786858],
    [54.357897, 10.864105],
    [54.366298, 10.899124],
    [54.382827, 10.92659],
    [54.384826, 10.949936],
    [54.381027, 11.021347],
    [54.411478, 11.091385],
    [54.437444, 10.999374],
    [54.524808, 11.008987],
    [54.538354, 11.063919],
    [54.521221, 11.186142],
    [54.500492, 11.236954],
    [54.404025, 11.321411],
    [54.39683, 11.317291],
    [54.394432, 11.178589],
    [54.335224, 11.086578],
    [54.191932, 11.112671],
    [54.071235, 10.881958],
    [54.086523, 10.807114],
    [54.044211, 10.760422],
    [53.995399, 10.792694],
    [53.995126, 10.859985],
    [53.980794, 10.885735],
    [53.9606, 10.887794],
    [53.951979, 10.859642],
    [53.934298, 10.86668],
    [53.91671, 10.869255],
    [53.892676, 10.815353],
    [53.894393, 10.802479],
    [53.897579, 10.776901],
    [53.908115, 10.755615],
    [53.907711, 10.722313],
    [53.898642, 10.700769],
    [53.899554, 10.696564],
    [53.890653, 10.660172],
    [53.864949, 10.629272],
    [53.845104, 10.651245],
    [53.836596, 10.684547],
    [53.844091, 10.720596],
    [53.879321, 10.730896],
    [53.898642, 10.700769],
    [53.898642, 10.700769],
    [53.907711, 10.722313],
    [53.908115, 10.755615],
    [53.897579, 10.776901],
    [53.894393, 10.802479],
    [53.892676, 10.815353],
    [53.91671, 10.869255],
    [53.934298, 10.86668],
    [53.951979, 10.859642],
    [53.9606, 10.887794],
    [54.00791, 11.03508],
    [54.015576, 11.090698],
    [54.014769, 11.186829],
    [54.009121, 11.197815],
    [53.992977, 11.203308],
    [53.982884, 11.23558],
    [53.988027, 11.250858],
    [53.983384, 11.263046],
    [53.970865, 11.257381],
    [53.967265, 11.249657],
    [53.944438, 11.24897],
    [53.93494, 11.25927],
    [53.930695, 11.285362],
    [53.936961, 11.299782],
    [53.940396, 11.312828],
    [53.958782, 11.326218],
    [53.95858, 11.338921],
    [53.936556, 11.362267],
    [53.935344, 11.368103],
    [53.939184, 11.385612],
    [53.934737, 11.409302],
    [53.96875, 11.372223],
    [53.998154, 11.370506],
    [54.026801, 11.469727],
    [54.099147, 11.55899],
    [54.15387, 11.682587],
    [54.151457, 11.78009],
    [54.149849, 11.824036],
    [54.179597, 11.999817],
    [54.188437, 12.10144],
    [54.194865, 12.133026],
    [54.249461, 12.201691],
    [54.286353, 12.308807],
    [54.378438, 12.399445],
    [54.394432, 12.432404],
    [54.487073, 12.505188],
    [54.490263, 12.53952],
    [54.465528, 12.546387],
    [54.444771, 12.922668],
    [54.461537, 13.042145],
    [54.591441, 13.084717],
    [54.678079, 13.272858],
    [54.686018, 13.443146],
    [54.659019, 13.444519],
    [54.635181, 13.395081],
    [54.584279, 13.422546],
    [54.577912, 13.456879],
    [54.592237, 13.639526],
    [54.559601, 13.698578],
    [54.513389, 13.699951],
    [54.475903, 13.592834],
    [54.408821, 13.613434],
    [54.388835, 13.710938],
    [54.337626, 13.771362],
    [54.315201, 13.735657],
    [54.269515, 13.731537],
    [54.264703, 13.709564],
    [54.32161, 13.493958],
    [54.265505, 13.40332],
    [54.244907, 13.435593],
    [54.230059, 13.422546],
    [54.187493, 13.333969],
    [54.181867, 13.425293],
    [54.094174, 13.460312],
    [54.088134, 13.488464],
    [54.121548, 13.469238],
    [54.138849, 13.608627],
    [54.17383, 13.697891],
    [54.182008, 13.813934],
    [54.118469, 13.859253],
    [54.088939, 13.903198],
    [54.06638, 13.994522],
    [54.015173, 14.082413],
    [53.955419, 14.17717],
    [53.93117, 14.227295],
    [53.925914, 14.264374],
    [53.914319, 14.324112],
    [53.913105, 14.357758],
    [53.920587, 14.402733],
    [53.965518, 14.4841],
    [54.154956, 15.281982],
    [54.182289, 15.501709],
    [54.240112, 15.792847],
    [54.262577, 16.048279],
    [54.299457, 16.160889],
    [54.535984, 16.468506],
    [54.550881, 16.512451],
    [54.211773, 16.847534],
    [53.966912, 17.352905],
    [53.756344, 17.929688],
    [53.675073, 18.858032],
    [53.717353, 19.671021],
    [53.873097, 20.352173],
    [54.102409, 21.137695],
    [54.39767, 21.313477],
    [54.770118, 21.373901],
    [54.939509, 21.234512],
    [55.193529, 21.154175],
    [55.211535, 21.21666],
    [55.204874, 21.226959],
    [55.198212, 21.223526],
    [55.209703, 21.278801],
    [55.34171, 21.186447],
    [55.416037, 21.236572],
    [55.622249, 21.163445],
    [55.655156, 21.134605],
    [55.661724, 21.135979],
    [55.672761, 21.142502],
    [55.712254, 21.116581],
    [55.721343, 21.103878],
    [55.729947, 21.078644],
    [55.730624, 21.08345],
    [55.784817, 21.065598],
    [55.878912, 21.049118],
    [55.920291, 21.046028],
    [56.06644, 21.047058],
    [56.251514, 20.948181],
    [56.368825, 20.959167],
    [56.519125, 20.959167],
    [56.590271, 21.000366],
    [56.835978, 21.036072],
    [56.952988, 21.280518],
    [56.997502, 21.364288],
    [57.038003, 21.395874],
    [57.071853, 21.413727],
    [57.170764, 21.395874],
    [57.29934, 21.40686],
    [57.391963, 21.52359],
    [57.428947, 21.585388],
    [57.5743, 21.687012],
    [57.603265, 21.818848],
    [57.612093, 21.96167],
    [57.764776, 22.598877],
    [57.754996, 22.615356],
    [57.697066, 22.589264],
    [57.640035, 22.607117],
    [57.592963, 22.642822],
    [57.55025, 22.70874],
    [57.516339, 22.807617],
    [57.463198, 22.901001],
    [57.421812, 22.947693],
    [57.38186, 23.049316],
    [57.370014, 23.131714],
    [57.162089, 23.249817],
    [57.102205, 23.256683],
    [57.054437, 23.345947],
    [57.03875, 23.481903],
    [57.030773, 23.496323],
    [56.980668, 23.556061],
    [56.973933, 23.596573],
    [56.963827, 23.629532],
    [56.975055, 23.781967],
    [57.000625, 23.892517],
    [57.055931, 24.013367],
    [57.065223, 24.02813],
    [57.079691, 24.091644],
    [57.09828, 24.152069],
    [57.123261, 24.205971],
    [57.150656, 24.237213],
    [55.107916, 24.104004],
    [54.051004, 23.356934],
    [53.348584, 22.631836],
    [53.151383, 20.192871],
    [53.069855, 19.113464],
    [52.851469, 18.844299],
    [52.838198, 18.695984],
    [52.86142, 18.547668],
    [52.970725, 18.352661],
    [52.993876, 18.27301],
    [52.391274, 14.449768],
    [52.329213, 14.414063],
    [52.267065, 14.477234],
    [52.108867, 14.699707],
    [51.078336, 15.732422],
    [50.77364, 16.358643],
    [50.354924, 17.53418],
    [50.101908, 18.533936],
    [50.003149, 19.390869],
    [49.953694, 19.819336],
    [49.967829, 20.214844],
    [49.748266, 21.159668],
    [49.55622, 22.510986],
    [49.383624, 23.120728],
  ],
];

const coordinates_1351 = [
  [
    [57.150656, 24.237213],
    [55.107916, 24.104004],
    [54.051004, 23.356934],
    [53.348584, 22.631836],
    [53.151383, 20.192871],
    [53.069855, 19.113464],
    [52.851469, 18.844299],
    [52.838198, 18.695984],
    [52.86142, 18.547668],
    [52.970725, 18.352661],
    [52.993876, 18.27301],
    [52.391274, 14.449768],
    [52.329213, 14.414063],
    [52.267065, 14.477234],
    [52.108867, 14.699707],
    [51.078336, 15.732422],
    [50.77364, 16.358643],
    [50.354924, 17.53418],
    [50.101908, 18.533936],
    [50.003149, 19.390869],
    [49.953694, 19.819336],
    [49.967829, 20.214844],
    [49.748266, 21.159668],
    [49.55622, 22.510986],
    [49.383624, 23.120728],
    [51.016174, 24.071045],
    [51.962546, 24.301758],
    [53.282951, 24.807129],
    [54.461737, 26.037598],
    [55.644739, 27.04834],
    [56.889203, 28.322754],
    [57.614226, 28.718262],
    [59.419025, 27.649841],
    [59.451637, 27.394409],
    [59.451637, 26.94397],
    [59.551512, 26.636353],
    [59.547336, 26.545715],
    [59.527842, 26.556702],
    [59.527842, 26.499023],
    [59.547336, 26.449585],
    [59.561254, 26.339722],
    [59.591852, 26.262817],
    [59.593242, 26.114502],
    [59.641862, 26.056824],
    [59.626589, 25.856323],
    [59.657614, 25.438843],
    [59.540862, 25.477295],
    [59.510218, 25.339966],
    [59.544552, 25.161438],
    [59.504155, 24.933472],
    [59.545944, 24.908752],
    [59.591852, 24.741211],
    [58.817724, 21.335449],
    [57.872222, 21.621094],
    [57.766901, 23.466797],
  ],
];

const coordinates_1352 = [
  [
    [51.016174, 24.071045],
    [51.962546, 24.301758],
    [53.282951, 24.807129],
    [54.461737, 26.037598],
    [55.644739, 27.04834],
    [56.889203, 28.322754],
    [57.614226, 28.718262],
    [59.419025, 27.649841],
    [59.699212, 27.965698],
    [59.787749, 28.052216],
    [59.778764, 28.207397],
    [59.710954, 28.23349],
    [59.690169, 28.230743],
    [59.675611, 28.402405],
    [59.821593, 28.436737],
    [59.847126, 28.530121],
    [59.851264, 28.549347],
    [59.795349, 28.712769],
    [59.820454, 28.954468],
    [59.865987, 29.039612],
    [59.915589, 28.990173],
    [59.9926, 29.11377],
    [59.826459, 30.300293],
    [60.219832, 38.067627],
    [57.673611, 37.705078],
    [55.645359, 36.5625],
    [53.155994, 36.958008],
    [51.673982, 34.082336],
  ],
];

const coordinates_1353 = [
  [
    [60.219832, 38.067627],
    [60.47536, 42.044678],
    [60.3279, 42.654419],
    [59.973432, 43.308105],
    [59.033207, 44.626465],
    [58.120548, 44.714355],
    [56.5, 45.703125],
    [54.969416, 42.54],
    [53.155994, 36.958008],
    [55.645359, 36.5625],
    [57.673611, 37.705078],
  ],
];

const DiseaseYears = [
  { coordinates: coordinates_1346, colour: "#ff0000", date: "v. 1346" },
  { coordinates: coordinates_1347, colour: "#f79f66", date: "v. 1347" },
  { coordinates: coordinates_1348, colour: "#fc5d23", date: "v. 1348" },
  { coordinates: coordinates_1349, colour: "#fc2356", date: "v. 1349" },
  { coordinates: coordinates_1350, colour: "#fc23c2", date: "v. 1350" },
  { coordinates: coordinates_1351, colour: "#c923fc", date: "v. 1351" },
  { coordinates: coordinates_1352, colour: "#5d23fc", date: "v. 1352" },
  { coordinates: coordinates_1353, colour: "#2356fc", date: "v. 1353" },
  { coordinates: [], colour: "", date: "Kaikki vuodet" },
];

const v1346 = DiseaseYears[0];
const v1347 = DiseaseYears[1];
const v1348 = DiseaseYears[2];
const v1349 = DiseaseYears[3];
const v1350 = DiseaseYears[4];
const v1351 = DiseaseYears[5];
const v1352 = DiseaseYears[6];
const v1353 = DiseaseYears[7];

export {
  DiseaseYears as default,
  v1346,
  v1347,
  v1348,
  v1349,
  v1350,
  v1351,
  v1352,
  v1353,
};
